<template>
  <div>
    <div class="SelTop">
      <div class="showDate" v-show="showDate">
        <ul>
          <li>
            数据更新时间：每日16:00-17:00为更新高峰，更新截止当日15:30产生的数据，
          </li>
          <li>关帐周更新如有延迟请谅解。</li>
          <li>FTZ数据更新时间：每日18：00左右更新截止前日24：00的FTZ数据</li>
        </ul>
      </div>

      <div class="sel_right" @click="showUpdata()">
        <p>更新时间说明</p>
        <b>!</b>
      </div>
    </div>

    <div class="clickInfo">
      <p><van-icon name="arrow-down" /> Channel Split</p>
      <p style="margin-right: 25px">
        Brand Split
        <van-icon name="arrow-down" />
      </p>
    </div>

    <div style="padding: 0 10px">
      <van-row
        type="flex"
        justify="center"
        style="height: 30px;
          line-height: 30px;
          font-weight: 600;
          color: rgb(255, 255, 255);
          font-size: 14px;
          background-color: #01B198;
          text-align: center;
        "
        class="OneTie OneTieactive"
      >
        <van-col span="12" style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
          >Sell in
        </van-col>
        <van-col span="12"> Sell out </van-col>
      </van-row>

      <div class="box" v-for="(item, i) in tableList" :key="i">
        <van-row
          type="flex"
          justify="center"
          class="OneTie OneTieactive"
          @click.stop="changeImg($event)"
        >
          <van-col span="2">
            <div class="redPlus">
              <img src="../../../assets/jpg/icon-1-down.svg" alt />
            </div>
          </van-col>

          <van-col span="20">
            <van-row>
              <van-col span="24">
                <div class="title">
                  {{ item.level1 }}
                </div>
              </van-col>
            </van-row>

            <van-row>
              <van-col span="7">
                <div class="proBoxsLeft">
                  <div class="tableLeft progressBox">
                    <div class="tabMid">
                      <b :class="item.inClass11">{{
                        item.SELLIN_SALES_VALUE | NumFormat
                      }}</b>
                    </div>
                    <div
                      class="progress"
                      style="display: flex; flex-direction: column"
                    >
                      <span>
                        <p
                          :class="item.inClass1"
                          :style="'width:' + item.inWidth1"
                        >
                          {{
                            item.SELLIN_SALES_VALUE == 0 ||
                            item.SELLIN_TARGET_VALUE1 == 0
                              ? 0 + "%"
                              : (
                                  (item.SELLIN_SALES_VALUE /
                                    item.SELLIN_TARGET_VALUE1) *
                                  100
                                ).toFixed(1) + "%"
                          }}
                        </p>
                      </span>
                      <!-- <div class="textTitle">VS RBP</div> -->
                    </div>
                    <!-- <div class="progress" style="display: flex; flex-direction: column">
                 
                      <span>
                        <p
                          :class="item.inClass2"
                          :style="'width:' + item.inWidth2"
                        >
                          {{
                            item.SELLIN_SALES_VALUE == 0 ||
                            item.SELLIN_TARGET_VALUE2 == 0
                              ? 0 + "%"
                              : (
                                  (item.SELLIN_SALES_VALUE /
                                    item.SELLIN_TARGET_VALUE2) *
                                  100
                                ).toFixed(1) + "%"
                          }}
                        </p>
                      </span>

                      <div class="textTitle">VS MMF</div>
                    </div> -->
                  </div>
                </div>
              </van-col>

              <van-col span="3">
                <div
                  class="tableRight middleContentCenter"
                  style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                >
                  <div class="rightFlex">
                    <span>{{ item.SELLIN_TARGET_VALUE1 | NumFormat }}</span>
                  </div>
                  <!-- <div class="rightFlex">
                    <span>{{ item.SELLIN_TARGET_VALUE2 | NumFormat }}</span>
                  </div> -->

                  <div class="rightFlex">
                    <span>{{ item.SELLIN_BTG1 | NumFormat }}</span>
                  </div>

                  <div class="rightFlex">
                    <span
                      >{{
                        (weekPatternFlag == true
                          ? item.weekPattern * 100
                          : item.timeGone * 100) | NumFormat
                      }}%</span
                    >
                  </div>
                  <!-- weekPattern  weekPatternSellout -->

                  <!-- <div class="rightFlex">
                    <span>{{ item.SELLIN_BTG2 | NumFormat }}</span>
                  </div> -->

                  <!-- <div class="rightFlex vsProgress">
                    <span>
                      <p
                        :class="
                          parseFloat(item.SELLIN_VS_LY) <
                            typeValue.timeGone * 100 &&
                          parseFloat(item.SELLIN_VS_LY) >
                            typeValue.timeGone * 100 - 5
                            ? 'pinCol'
                            : parseFloat(item.SELLIN_VS_LY) >=
                              typeValue.timeGone * 100
                            ? 'helthyCol'
                            : 'noticeCol'
                        "
                        :style="
                          'width:' +
                          (parseFloat(item.SELLIN_VS_LY) >= 100
                            ? '97%'
                            : item.SELLIN_VS_LY)
                        "
                      >
                        {{
                          item.SELLIN_VS_LY == "" ? 0 + "%" : item.SELLIN_VS_LY
                        }}
                      </p>
                    </span>
                  </div> -->
                </div>
              </van-col>

              <van-col span="4">
                <div
                  class="tableCenter middleContentCenter"
                  style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                >
                  <div class="centerFlex">{{ type1 }}</div>
                  <!-- <div class="centerFlex">{{ type2 }}</div> -->
                  <div class="centerFlex">{{ type3 }}</div>
                  <!-- <div class="centerFlex">{{ type4 }}</div> -->

                  <!-- <div class="centerFlex" style="visibility:hidden">
                     vs.LY
                  </div> -->

                  <div class="centerFlex">{{ type5 }}</div>
                </div>
              </van-col>

              <van-col span="3">
                <div class="tableLeft middleContentCenter">
                  <div class="leftFlex">
                    <span>{{ item.SELLOUT_TARGET_VALUE1 | NumFormat }}</span>
                  </div>

                  <!-- <div class="leftFlex">
                    <span>{{ item.SELLOUT_TARGET_VALUE2 | NumFormat }}</span>
                  </div> -->

                  <div class="leftFlex">
                    <span>{{ item.SELLOUT_BTG1 | NumFormat }}</span>
                  </div>

                  <div class="leftFlex">
                    <span
                      >{{
                        (weekPatternFlag == true
                          ? item.weekPatternSellout * 100
                          : item.timeGoneSellout * 100) | NumFormat
                      }}%</span
                    >
                  </div>
                  <!-- weekPattern  weekPatternSellout -->

                  <!-- <div class="leftFlex">
                    <span>{{ item.SELLOUT_BTG2 | NumFormat }}</span>
                  </div> -->

                  <!-- <div class="leftFlex vsProgress">
                    <span>
                      <p
                        :class="
                          parseFloat(item.SELLOUT_VS_LY) <
                            typeValue.timeGoneSellout * 100 &&
                          parseFloat(item.SELLOUT_VS_LY) >
                            typeValue.timeGoneSellout * 100 - 5
                            ? 'pinCol'
                            : parseFloat(item.SELLOUT_VS_LY) >=
                              typeValue.timeGoneSellout * 100
                            ? 'helthyCol'
                            : 'noticeCol'
                        "
                        :style="
                          'width:' +
                          (parseFloat(item.SELLOUT_VS_LY) >= 100
                            ? '97%'
                            : item.SELLOUT_VS_LY)
                        "
                      >
                        {{
                          item.SELLOUT_VS_LY == ""
                            ? 0 + "%"
                            : item.SELLOUT_VS_LY
                        }}
                      </p>
                    </span>
                  </div> -->
                </div>
              </van-col>

              <van-col span="7">
                <div class="proBoxsRight">
                  <div class="tableLeft progressBox">
                    <div class="tabMid">
                      <b :class="item.outClass11">
                        {{ item.SELLOUT_SALES_VALUE | NumFormat }}
                      </b>
                    </div>
                    <div
                      class="progress"
                      style="display: flex; flex-direction: column"
                    >
                      <span>
                        <p
                          :class="item.outClass1"
                          :style="'width:' + item.outWidth1"
                        >
                          {{
                            item.SELLOUT_SALES_VALUE == 0 ||
                            item.SELLOUT_TARGET_VALUE1 == 0
                              ? 0
                              : (
                                  (item.SELLOUT_SALES_VALUE /
                                    item.SELLOUT_TARGET_VALUE1) *
                                  100
                                ).toFixed(1) + "%"
                          }}
                        </p>
                      </span>

                      <!-- <div class="textTitle">VS RBP</div> -->
                    </div>
                    <!-- <div class="progress" style="display: flex; flex-direction: column">
                      <span>
                        <p
                          :class="item.outClass2"
                          :style="'width:' + item.outWidth2"
                        >
                          {{
                            item.SELLOUT_SALES_VALUE == 0 ||
                            item.SELLOUT_TARGET_VALUE2 == 0
                              ? 0
                              : (
                                  (item.SELLOUT_SALES_VALUE /
                                    item.SELLOUT_TARGET_VALUE2) *
                                  100
                                ).toFixed(1) + "%"
                          }}
                        </p>
                      </span>

                      <div class="textTitle">VS MMF</div>
                    </div> -->
                  </div>
                </div>
              </van-col>
            </van-row>
          </van-col>

          <van-col span="2">
            <div
              class="red"
              style="padding: 0 12px"
              @click.stop="changeBrand($event)"
            >
              <img src="../../../assets/jpg/icon-tag1.svg" alt="" />
            </div>
          </van-col>
        </van-row>

        <!-- Brand List1 start  -->
        <div
          v-show="brand1"
          v-for="brandItem in item.level1ByBrandList"
          :key="brandItem.brandCd"
          class="BrandOneTie"
        >
          <van-row
            type="flex"
            justify="center"
            class="BrandThrTie"
            :assgin="brandItem.brandCd"
          >
            <van-col span="2"></van-col>

            <van-col span="20">
              <van-row>
                <van-col span="24">
                  <div class="title">
                    {{ brandItem.brandCd }}
                  </div>
                </van-col>
              </van-row>

              <van-row>
                <van-col span="7">
                  <div class="proBoxsLeft">
                    <div class="tableLeft progressBox">
                      <div class="tabMid">
                        <b :class="brandItem.inClass11">{{
                          brandItem.SELLIN_SALES_VALUE | NumFormat
                        }}</b>
                      </div>
                      <div
                        class="progress"
                        style="display: flex; flex-direction: column"
                      >
                        <span>
                          <p
                            :class="brandItem.inClass1"
                            :style="'width:' + brandItem.inWidth1"
                          >
                            {{
                              brandItem.SELLIN_SALES_VALUE == 0 ||
                              brandItem.SELLIN_TARGET_VALUE1 == 0
                                ? 0 + "%"
                                : (
                                    (brandItem.SELLIN_SALES_VALUE /
                                      brandItem.SELLIN_TARGET_VALUE1) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>

                        <!-- <div class="textTitle">VS RBP</div> -->
                      </div>

                      <!-- <div class="progress"   style="display: flex; flex-direction: column">
                        <span>
                          <p
                            :class="brandItem.inClass2"
                            :style="'width:' + brandItem.inWidth2"
                          >
                            {{
                              brandItem.SELLIN_SALES_VALUE == 0 ||
                              brandItem.SELLIN_TARGET_VALUE2 == 0
                                ? 0 + "%"
                                : (
                                    (brandItem.SELLIN_SALES_VALUE /
                                      brandItem.SELLIN_TARGET_VALUE2) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>   <div class="textTitle">VS MMF</div>
                      </div> -->
                    </div>
                  </div>
                </van-col>

                <van-col span="3">
                  <div
                    class="tableRight middleContentCenter"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="rightFlex">
                      <span>{{
                        brandItem.SELLIN_TARGET_VALUE1 | NumFormat
                      }}</span>
                    </div>

                    <!-- <div class="rightFlex">
                      <span>{{
                        brandItem.SELLIN_TARGET_VALUE2 | NumFormat
                      }}</span>
                    </div> -->
                    <div class="rightFlex">
                      <span>{{ brandItem.SELLIN_BTG1 | NumFormat }}</span>
                    </div>

                    <div class="rightFlex">
                      <span
                        >{{
                          (weekPatternFlag == true
                            ? brandItem.weekPattern * 100
                            : brandItem.timeGone * 100) | NumFormat
                        }}%</span
                      >
                    </div>
                    <!-- <div class="rightFlex">
                      <span>{{ brandItem.SELLIN_BTG2 | NumFormat }}</span>
                    </div> -->
                    <!-- <div class="rightFlex vsProgress">
               
                      <span>
                        <p
                          :class="
                            parseFloat(brandItem.SELLIN_VS_LY) <
                              typeValue.timeGone * 100 &&
                            parseFloat(brandItem.SELLIN_VS_LY) >
                              typeValue.timeGone * 100 - 5
                              ? 'pinCol'
                              : parseFloat(brandItem.SELLIN_VS_LY) >=
                                typeValue.timeGone * 100
                              ? 'helthyCol'
                              : 'noticeCol'
                          "
                          :style="
                            'width:' +
                            (parseFloat(brandItem.SELLIN_VS_LY) >= 100
                              ? '97%'
                              : brandItem.SELLIN_VS_LY)
                          "
                        >
                          {{
                            brandItem.SELLIN_VS_LY == ""
                              ? 0 + "%"
                              : brandItem.SELLIN_VS_LY
                          }}
                        </p>
                      </span>
                    </div> -->
                  </div>
                </van-col>

                <van-col span="4">
                  <div
                    class="tableCenter middleContentCenter"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="centerFlex">{{ type1 }}</div>
                    <!-- <div class="centerFlex">{{ type2 }}</div> -->
                    <div class="centerFlex">{{ type3 }}</div>
                    <!-- <div class="centerFlex">{{ type4 }}</div> -->

                    <!-- <div class="centerFlex" style="visibility:hidden">
                      vs.LY
                    </div> -->
                    <div class="centerFlex">{{ type5 }}</div>
                  </div>
                </van-col>

                <van-col span="3">
                  <div class="tableLeft middleContentCenter">
                    <div class="leftFlex">
                      <span
                        :class="
                          brandItem.targetValue * (achVing / 100) -
                            brandItem.salesValue <=
                          0
                            ? ' helthyFormat'
                            : 'noticeFormat'
                        "
                      >
                        <span>{{
                          brandItem.SELLOUT_TARGET_VALUE1 | NumFormat
                        }}</span>
                      </span>
                    </div>

                    <!-- <div class="leftFlex">
                      <span>{{
                        brandItem.SELLOUT_TARGET_VALUE2 | NumFormat
                      }}</span>
                    </div> -->

                    <div class="leftFlex">
                      <span>{{ brandItem.SELLOUT_BTG1 | NumFormat }}</span>
                    </div>

                    <div class="leftFlex">
                      <span
                        >{{
                          (weekPatternFlag == true
                            ? brandItem.weekPatternSellout * 100
                            : brandItem.timeGoneSellout * 100) | NumFormat
                        }}%</span
                      >
                    </div>

                    <!-- <div class="leftFlex">
                      <span>{{ brandItem.SELLOUT_BTG2 | NumFormat }}</span>
                    </div> -->

                    <!-- <div class="leftFlex vsProgress">
                  
                      <span>
                        <p
                          :class="
                            parseFloat(brandItem.SELLOUT_VS_LY) <
                              typeValue.timeGoneSellout * 100 &&
                            parseFloat(brandItem.SELLOUT_VS_LY) >
                              typeValue.timeGoneSellout * 100 - 5
                              ? 'pinCol'
                              : parseFloat(brandItem.SELLOUT_VS_LY) >=
                                typeValue.timeGoneSellout * 100
                              ? 'helthyCol'
                              : 'noticeCol'
                          "
                          :style="
                            'width:' +
                            (parseFloat(brandItem.SELLOUT_VS_LY) >= 100
                              ? '97%'
                              : brandItem.SELLOUT_VS_LY)
                          "
                        >
                          {{
                            brandItem.SELLOUT_VS_LY == ""
                              ? 0 + "%"
                              : brandItem.SELLOUT_VS_LY
                          }}
                        </p>
                      </span>
                    </div> -->
                  </div>
                </van-col>

                <van-col span="7">
                  <div class="proBoxsRight">
                    <div class="tableLeft progressBox">
                      <div class="tabMid">
                        <b :class="brandItem.outClass11">{{
                          brandItem.SELLOUT_SALES_VALUE | NumFormat
                        }}</b>
                      </div>
                      <div
                        class="progress"
                        style="display: flex; flex-direction: column"
                      >
                        <span>
                          <p
                            :class="brandItem.outClass1"
                            :style="'width:' + brandItem.outWidth1"
                          >
                            {{
                              brandItem.SELLOUT_SALES_VALUE == 0 ||
                              brandItem.SELLOUT_TARGET_VALUE1 == 0
                                ? 0 + "%"
                                : (
                                    (brandItem.SELLOUT_SALES_VALUE /
                                      brandItem.SELLOUT_TARGET_VALUE1) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>
                        <!-- <div class="textTitle">VS RBP</div> -->
                      </div>

                      <!-- <div class="progress" style="display: flex; flex-direction: column">
                        <span>
                          <p
                            :class="brandItem.outClass2"
                            :style="'width:' + brandItem.outWidth2"
                          >
                            {{
                              brandItem.SELLOUT_SALES_VALUE == 0 ||
                              brandItem.SELLOUT_TARGET_VALUE2 == 0
                                ? 0 + "%"
                                : (
                                    (brandItem.SELLOUT_SALES_VALUE /
                                      brandItem.SELLOUT_TARGET_VALUE2) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>

                      
                        <div class="textTitle">VS MMF</div>
                      </div> -->
                    </div>
                  </div>
                </van-col>
              </van-row>
            </van-col>

            <van-col span="2"></van-col>
          </van-row>
        </div>
        <!-- Brand List1  end  -->

        <div
          v-show="isShow"
          v-for="item1 in item.levelList2"
          :key="item1.level2"
          class="ChannelList1"
        >
          <van-row
            type="flex"
            justify="center"
            class="OneTie TwoTieactive"
            :assgin="item1.level2"
            @click.stop="changeChannel($event), changeChannelTwo($event)"
          >
            <van-col span="2">
              <div class="redPlus" v-show="item1.levelList3.length > 0">
                <img src="../../../assets/jpg/icon-2-right.svg" 
                style="width: 18px; height: 18px"
                alt />
              </div>
            </van-col>

            <van-col span="20">
              <van-row>
                <van-col span="24">
                  <div class="title">
                    {{ item1.level2 }}
                  </div>
                </van-col>
              </van-row>

              <van-row>
                <van-col span="7">
                  <div class="proBoxsLeft">
                    <div class="tableLeft progressBox">
                      <div class="tabMid">
                        <b :class="item1.inClass11">{{
                          item1.SELLIN_SALES_VALUE | NumFormat
                        }}</b>
                      </div>

                      <div
                        class="progress"
                        style="display: flex; flex-direction: column"
                      >
                        <span>
                          <p
                            :class="item1.inClass1"
                            :style="'width:' + item1.inWidth1"
                          >
                            {{
                              item1.SELLIN_SALES_VALUE == 0 ||
                              item1.SELLIN_TARGET_VALUE1 == 0
                                ? 0 + "%"
                                : (
                                    (item1.SELLIN_SALES_VALUE /
                                      item1.SELLIN_TARGET_VALUE1) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>

                        <!-- <div class="textTitle">VS RBP</div> -->
                      </div>

                      <!-- <div class="progress"  style="display: flex; flex-direction: column">
                        <span>
                          <p
                            :class="item1.inClass2"
                            :style="'width:' + item1.inWidth2"
                          >
                            {{
                              item1.SELLIN_SALES_VALUE == 0 ||
                              item1.SELLIN_TARGET_VALUE2 == 0
                                ? 0 + "%"
                                : (
                                    (item1.SELLIN_SALES_VALUE /
                                      item1.SELLIN_TARGET_VALUE2) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>
                         <div class="textTitle">VS MMF</div>
                      </div> -->
                    </div>
                  </div>
                </van-col>

                <van-col span="3">
                  <div
                    class="tableRight middleContentCenter"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="rightFlex">
                      <span>{{ item1.SELLIN_TARGET_VALUE1 | NumFormat }}</span>
                    </div>

                    <!-- <div class="rightFlex">
                      <span>{{ item1.SELLIN_TARGET_VALUE2 | NumFormat }}</span>
                    </div> -->

                    <div class="rightFlex">
                      <span>{{ item1.SELLIN_BTG1 | NumFormat }}</span>
                    </div>

                    <div class="rightFlex">
                      <span
                        >{{
                          (weekPatternFlag == true
                            ? item1.weekPattern * 100
                            : item1.timeGone * 100) | NumFormat
                        }}%</span
                      >
                    </div>

                    <!-- <div class="rightFlex">
                      <span>{{ item1.SELLIN_BTG2 | NumFormat }}</span>
                    </div> -->

                    <!-- <div class="rightFlex vsProgress">
                      <span>
                        <p
                          :class="
                            parseFloat(item1.SELLIN_VS_LY) <
                              typeValue.timeGone * 100 &&
                            parseFloat(item1.SELLIN_VS_LY) >
                              typeValue.timeGone * 100 - 5
                              ? 'pinCol'
                              : parseFloat(item1.SELLIN_VS_LY) >=
                                typeValue.timeGone * 100
                              ? 'helthyCol'
                              : 'noticeCol'
                          "
                          :style="
                            'width:' +
                            (parseFloat(item1.SELLIN_VS_LY) >= 100
                              ? '97%'
                              : item1.SELLIN_VS_LY)
                          "
                        >
                          {{
                            item1.SELLIN_VS_LY == ""
                              ? 0 + "%"
                              : item1.SELLIN_VS_LY
                          }}
                        </p>
                      </span>
                    </div> -->
                  </div>
                </van-col>

                <van-col span="4">
                  <div
                    class="tableCenter middleContentCenter"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="centerFlex">{{ type1 }}</div>
                    <!-- <div class="centerFlex">{{ type2 }}</div> -->
                    <div class="centerFlex">{{ type3 }}</div>
                    <!-- <div class="centerFlex">{{ type4 }}</div> -->

                    <!-- <div class="centerFlex" style="visibility:hidden">
                      vs.LY
                    </div> -->
                    <div class="centerFlex">{{ type5 }}</div>
                  </div>
                </van-col>

                <van-col span="3">
                  <div class="tableLeft middleContentCenter">
                    <div class="leftFlex">
                      <span>{{ item1.SELLOUT_TARGET_VALUE1 | NumFormat }}</span>
                    </div>
                    <!-- <div class="leftFlex">
                      <span>
                        <span>{{
                          item1.SELLOUT_TARGET_VALUE2 | NumFormat
                        }}</span>
                      </span>
                    </div> -->

                    <div class="leftFlex">
                      <span>{{ item1.SELLOUT_BTG1 | NumFormat }}</span>
                    </div>

                    <div class="leftFlex">
                      <span
                        >{{
                          (weekPatternFlag == true
                            ? item1.weekPatternSellout * 100
                            : item1.timeGoneSellout * 100) | NumFormat
                        }}%</span
                      >
                    </div>

                    <!-- <div class="leftFlex">
                      <span>{{ item1.SELLOUT_BTG2 | NumFormat }}</span>
                    </div> -->

                    <!-- <div class="leftFlex vsProgress">
                      <span>
                        <p
                          :class="
                            parseFloat(item1.SELLOUT_VS_LY) <
                              typeValue.timeGoneSellout * 100 &&
                            parseFloat(item1.SELLOUT_VS_LY) >
                              typeValue.timeGoneSellout * 100 - 5
                              ? 'pinCol'
                              : parseFloat(item1.SELLOUT_VS_LY) >=
                                typeValue.timeGoneSellout * 100
                              ? 'helthyCol'
                              : 'noticeCol'
                          "
                          :style="
                            'width:' +
                            (parseFloat(item1.SELLOUT_VS_LY) >= 100
                              ? '97%'
                              : item1.SELLOUT_VS_LY)
                          "
                        >
                          {{
                            item1.SELLOUT_VS_LY == ""
                              ? 0 + "%"
                              : item1.SELLOUT_VS_LY
                          }}
                        </p>
                      </span>
                    </div> -->
                  </div>
                </van-col>

                <van-col span="7">
                  <div class="proBoxsRight">
                    <div class="tableLeft progressBox">
                      <div class="tabMid">
                        <b :class="item1.outClass11">
                          {{ item1.SELLOUT_SALES_VALUE | NumFormat }}
                        </b>
                      </div>

                      <div
                        class="progress"
                        style="display: flex; flex-direction: column"
                      >
                        <span>
                          <p
                            :class="item1.outClass1"
                            :style="'width:' + item1.outWidth1"
                          >
                            {{
                              item1.SELLOUT_SALES_VALUE == 0 ||
                              item1.SELLOUT_TARGET_VALUE1 == 0
                                ? 0 + "%"
                                : (
                                    (item1.SELLOUT_SALES_VALUE /
                                      item1.SELLOUT_TARGET_VALUE1) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>

                        <!-- <div class="textTitle">VS RBP</div> -->
                      </div>
                      <!-- <div class="progress"  style="display: flex; flex-direction: column">
                        <span>
                          <p
                            :class="item1.outClass2"
                            :style="'width:' + item1.outWidth2"
                          >
                            {{
                              item1.SELLOUT_SALES_VALUE == 0 ||
                              item1.SELLOUT_TARGET_VALUE2 == 0
                                ? 0 + "%"
                                : (
                                    (item1.SELLOUT_SALES_VALUE /
                                      item1.SELLOUT_TARGET_VALUE2) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>

                     
                        <div class="textTitle">VS MMF</div>
                      </div> -->
                    </div>
                  </div>
                </van-col>
              </van-row>
            </van-col>

            <van-col span="2">
              <div class="red" @click.stop="changeBrandTwo($event)">
                <img src="../../../assets/jpg/icon-tag1.svg" alt="" />
              </div>
            </van-col>
          </van-row>
          <!-- Brand List2 start-->
          <div
            v-show="brand2"
            v-for="brandItem1 in item1.level2ByBrandList"
            :key="brandItem1.brandCd"
            class="BrandTieTie"
          >
            <van-row
              type="flex"
              justify="center"
              class="BrandThrTie"
              :assgin="brandItem1.brandCd"
            >
              <van-col span="2"></van-col>

              <van-col span="20">
                <van-row>
                  <van-col span="24">
                    <div class="title">
                      {{ brandItem1.brandCd }}
                    </div>
                  </van-col>
                </van-row>

                <van-row>
                  <van-col span="7">
                    <div class="proBoxsLeft">
                      <div class="tableLeft progressBox">
                        <div class="tabMid">
                          <b :class="brandItem1.inClass11">
                            {{ brandItem1.SELLIN_SALES_VALUE | NumFormat }}
                          </b>
                        </div>

                        <div
                          class="progress"
                          style="display: flex; flex-direction: column"
                        >
                          <span>
                            <p
                              :class="brandItem1.inClass1"
                              :style="'width:' + brandItem1.inWidth1"
                            >
                              {{
                                brandItem1.SELLIN_SALES_VALUE == 0 ||
                                brandItem1.SELLIN_TARGET_VALUE1 == 0
                                  ? 0 + "%"
                                  : (
                                      (brandItem1.SELLIN_SALES_VALUE /
                                        brandItem1.SELLIN_TARGET_VALUE1) *
                                      100
                                    ).toFixed(1) + "%"
                              }}
                            </p>
                          </span>

                          <!-- <div class="textTitle">VS RBP</div> -->
                        </div>

                        <!-- <div class="progress"  style="display: flex; flex-direction: column">
                      
                          <span>
                            <p
                              :class="brandItem1.inClass2"
                              :style="'width:' + brandItem1.inWidth2"
                            >
                              {{
                                brandItem1.SELLIN_SALES_VALUE == 0 ||
                                brandItem1.SELLIN_TARGET_VALUE2 == 0
                                  ? 0 + "%"
                                  : (
                                      (brandItem1.SELLIN_SALES_VALUE /
                                        brandItem1.SELLIN_TARGET_VALUE2) *
                                      100
                                    ).toFixed(1) + "%"
                              }}
                            </p>
                          </span>


                          <div class="textTitle">VS MMF</div>

                        </div> -->
                      </div>
                    </div>
                  </van-col>

                  <van-col span="3">
                    <div
                      class="tableRight middleContentCenter"
                      style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                    >
                      <div class="rightFlex">
                        <span>
                          {{ brandItem1.SELLIN_TARGET_VALUE1 | NumFormat }}
                        </span>
                      </div>
                      <!-- <div class="rightFlex">
                        <span>
                          {{
                            brandItem1.SELLIN_TARGET_VALUE2 | NumFormat
                          }}</span
                        >
                      </div> -->

                      <div class="rightFlex">
                        <span> {{ brandItem1.SELLIN_BTG1 | NumFormat }}</span>
                      </div>

                      <div class="rightFlex">
                        <span
                          >{{
                            (weekPatternFlag == true
                              ? brandItem1.weekPattern * 100
                              : brandItem1.timeGone * 100) | NumFormat
                          }}%</span
                        >
                      </div>

                      <!-- <div class="rightFlex">
                        <span> {{ brandItem1.SELLIN_BTG2 | NumFormat }}</span>
                      </div> -->

                      <!-- <div class="rightFlex vsProgress">
                        <span>
                          <p
                            :class="
                              parseFloat(brandItem1.SELLIN_VS_LY) <
                                typeValue.timeGone * 100 &&
                              parseFloat(brandItem1.SELLIN_VS_LY) >
                                typeValue.timeGone * 100 - 5
                                ? 'pinCol'
                                : parseFloat(brandItem1.SELLIN_VS_LY) >=
                                  typeValue.timeGone * 100
                                ? 'helthyCol'
                                : 'noticeCol'
                            "
                            :style="
                              'width:' +
                              (parseFloat(brandItem1.SELLIN_VS_LY) >= 100
                                ? '97%'
                                : brandItem1.SELLIN_VS_LY)
                            "
                          >
                            {{
                              brandItem1.SELLIN_VS_LY == ""
                                ? 0 + "%"
                                : brandItem1.SELLIN_VS_LY
                            }}
                          </p>
                        </span>

                  
                      </div> -->
                    </div>
                  </van-col>

                  <van-col span="4">
                    <div
                      class="tableCenter middleContentCenter"
                      style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                    >
                      <div class="centerFlex">{{ type1 }}</div>
                      <!-- <div class="centerFlex">{{ type2 }}</div> -->
                      <div class="centerFlex">{{ type3 }}</div>
                      <!-- <div class="centerFlex">{{ type4 }}</div> -->

                      <!-- <div class="centerFlex" style="visibility:hidden">
                        vs.LY
                      </div> -->
                      <div class="centerFlex">{{ type5 }}</div>
                    </div>
                  </van-col>

                  <van-col span="3">
                    <div class="tableLeft middleContentCenter">
                      <!-- <div class="rightFlex">
                    <i>TGG22</i>
                  </div> -->
                      <div class="leftFlex">
                        <span>{{
                          brandItem1.SELLOUT_TARGET_VALUE1 | NumFormat
                        }}</span>
                      </div>
                      <!-- <div class="leftFlex">
                        <span>{{
                          brandItem1.SELLOUT_TARGET_VALUE2 | NumFormat
                        }}</span>
                      </div> -->

                      <div class="leftFlex">
                        <span>{{ brandItem1.SELLOUT_BTG1 | NumFormat }}</span>
                      </div>

                      <div class="leftFlex">
                        <span
                          >{{
                            (weekPatternFlag == true
                              ? brandItem1.weekPatternSellout * 100
                              : brandItem1.timeGoneSellout * 100) | NumFormat
                          }}%</span
                        >
                      </div>

                      <!-- <div class="leftFlex">
                        <span>{{ brandItem1.SELLOUT_BTG2 | NumFormat }}</span>
                      </div> -->

                      <!-- <div class="leftFlex vsProgress">
                 
                        <span>
                          <p
                            :class="
                              parseFloat(brandItem1.SELLOUT_VS_LY) <
                                typeValue.timeGoneSellout * 100 &&
                              parseFloat(brandItem1.SELLOUT_VS_LY) >
                                typeValue.timeGoneSellout * 100 - 5
                                ? 'pinCol'
                                : parseFloat(brandItem1.SELLOUT_VS_LY) >=
                                  typeValue.timeGoneSellout * 100
                                ? 'helthyCol'
                                : 'noticeCol'
                            "
                            :style="
                              'width:' +
                              (parseFloat(brandItem1.SELLOUT_VS_LY) >= 100
                                ? '97%'
                                : brandItem1.SELLOUT_VS_LY)
                            "
                          >
                            {{
                              brandItem1.SELLOUT_VS_LY == ""
                                ? 0 + "%"
                                : brandItem1.SELLOUT_VS_LY
                            }}
                          </p>
                        </span>
                      </div> -->
                    </div>
                  </van-col>

                  <van-col span="7">
                    <div class="proBoxsRight">
                      <div class="tableLeft progressBox">
                        <div class="tabMid">
                          <b :class="brandItem1.outClass11">
                            {{ brandItem1.SELLOUT_SALES_VALUE | NumFormat }}
                          </b>
                        </div>
                        <div
                          class="progress"
                          style="display: flex; flex-direction: column"
                        >
                          <span>
                            <p
                              :class="brandItem1.outClass1"
                              :style="'width:' + brandItem1.outWidth1"
                            >
                              {{
                                brandItem1.SELLOUT_SALES_VALUE == 0 ||
                                brandItem1.SELLOUT_TARGET_VALUE1 == 0
                                  ? 0 + "%"
                                  : (
                                      (brandItem1.SELLOUT_SALES_VALUE /
                                        brandItem1.SELLOUT_TARGET_VALUE1) *
                                      100
                                    ).toFixed(1) + "%"
                              }}
                            </p>
                          </span>
                          <!-- <div class="textTitle">VS RBP</div> -->
                        </div>
                        <!-- <div class="progress" style="display: flex; flex-direction: column">
                          <span>
                            <p
                              :class="brandItem1.outClass2"
                              :style="'width:' + brandItem1.outWidth2"
                            >
                              {{
                                brandItem1.SELLOUT_SALES_VALUE == 0 ||
                                brandItem1.SELLOUT_TARGET_VALUE2 == 0
                                  ? 0 + "%"
                                  : (
                                      (brandItem1.SELLOUT_SALES_VALUE /
                                        brandItem1.SELLOUT_TARGET_VALUE2) *
                                      100
                                    ).toFixed(1) + "%"
                              }}
                            </p>
                          </span>

                          <div class="textTitle">VS MMF</div>
                        </div> -->
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </van-col>

              <van-col span="2"></van-col>
            </van-row>
          </div>
          <!-- Brand List2   end-->

          <div
            v-show="isShow2"
            v-for="item2 in item1.levelList3"
            :key="item2.level3"
            class="TwoTieAct"
          >
            <van-row
              type="flex"
              justify="center"
              class="TwoTie"
              style="margin-bottom: 2px"
              v-if="item2.level3 != 'Mid'"
              @click.stop="changeChannelThr($event)"
            >
              <van-col span="2">
                <div class="redPlus" v-show="item2.levelList4.length > 0">
                  <img
                    src="../../../assets/jpg/icon-3-right.svg"
                    style="width: 18px; height: 18px"
                    alt
                  />
                </div>
              </van-col>

              <van-col span="20">
                <van-row>
                  <van-col span="24">
                    <div class="title">
                      {{ item2.level3 == "Mid" ? "Central" : item2.level3 }}
                    </div>
                  </van-col>
                </van-row>

                <van-row>
                  <van-col span="7">
                    <div class="proBoxsLeft">
                      <div class="tableLeft progressBox">
                        <div class="tabMid">
                          <b :class="item2.inClass11">
                            {{ item2.SELLIN_SALES_VALUE | NumFormat }}</b
                          >
                        </div>
                        <div
                          class="progress"
                          style="display: flex; flex-direction: column"
                        >
                          <span>
                            <p
                              :class="item2.inClass1"
                              :style="'width:' + item2.inWidth1"
                            >
                              {{
                                item2.SELLIN_SALES_VALUE == 0 ||
                                item2.SELLIN_TARGET_VALUE1 == 0
                                  ? 0 + "%"
                                  : (
                                      (item2.SELLIN_SALES_VALUE /
                                        item2.SELLIN_TARGET_VALUE1) *
                                      100
                                    ).toFixed(1) + "%"
                              }}
                            </p>
                          </span>

                          <!-- <div class="textTitle">VS RBP</div> -->
                        </div>
                        <!-- <div class="progress"  style="display: flex; flex-direction: column">
                     
                          <span>
                            <p
                              :class="item2.inClass2"
                              :style="'width:' + item2.inWidth2"
                            >
                              {{
                                item2.SELLIN_SALES_VALUE == 0 ||
                                item2.SELLIN_TARGET_VALUE2 == 0
                                  ? 0 + "%"
                                  : (
                                      (item2.SELLIN_SALES_VALUE /
                                        item2.SELLIN_TARGET_VALUE2) *
                                      100
                                    ).toFixed(1) + "%"
                              }}
                            </p>
                          </span>


                          <div class="textTitle">VS MMF</div>
                        </div> -->
                      </div>
                    </div>
                  </van-col>

                  <van-col span="3">
                    <div
                      class="tableRight middleContentCenter"
                      style="
                        margin-left: -5px;
                        border-right: 1px solid rgba(0, 0, 0, 0.1);
                      "
                    >
                      <div class="rightFlex">
                        <span>{{
                          item2.SELLIN_TARGET_VALUE1 | NumFormat
                        }}</span>
                      </div>
                      <!-- <div class="rightFlex">
                        <span>{{
                          item2.SELLIN_TARGET_VALUE2 | NumFormat
                        }}</span>
                      </div> -->
                      <div class="rightFlex">
                        <span>{{ item2.SELLIN_BTG1 | NumFormat }}</span>
                      </div>

                      <div class="rightFlex">
                        <span
                          >{{
                            (weekPatternFlag == true
                              ? item2.weekPattern * 100
                              : item2.timeGone * 100) | NumFormat
                          }}%</span
                        >
                      </div>

                      <!-- <div class="rightFlex">
                        <span>{{ item2.SELLIN_BTG2 | NumFormat }}</span>
                      </div> -->
                      <!-- <div class="rightFlex vsProgress">
                   
                        <span>
                          <p
                            :class="
                              parseFloat(item2.SELLIN_VS_LY) <
                                typeValue.timeGone * 100 &&
                              parseFloat(item2.SELLIN_VS_LY) >
                                typeValue.timeGone * 100 - 5
                                ? 'pinCol'
                                : parseFloat(item2.SELLIN_VS_LY) >=
                                  typeValue.timeGone * 100
                                ? 'helthyCol'
                                : 'noticeCol'
                            "
                            :style="
                              'width:' +
                              (parseFloat(item2.SELLIN_VS_LY) >= 100
                                ? '97%'
                                : item2.SELLIN_VS_LY)
                            "
                          >
                            {{
                              item2.SELLIN_VS_LY == ""
                                ? 0 + "%"
                                : item2.SELLIN_VS_LY
                            }}
                          </p>
                        </span>
                      </div> -->
                    </div>
                  </van-col>

                  <van-col span="4">
                    <div
                      class="tableCenter middleContentCenter"
                      style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                    >
                      <div class="centerFlex">{{ type1 }}</div>
                      <!-- <div class="centerFlex">{{ type2 }}</div> -->
                      <div class="centerFlex">{{ type3 }}</div>
                      <!-- <div class="centerFlex">{{ type4 }}</div> -->
                      <!-- <div class="centerFlex" style="visibility:hidden">
                        vs.LY
                      </div> -->
                      <div class="centerFlex">{{ type5 }}</div>
                    </div>
                  </van-col>

                  <van-col span="3">
                    <div class="tableLeft middleContentCenter">
                      <div class="leftFlex">
                        <span>{{
                          item2.SELLOUT_TARGET_VALUE1 | NumFormat
                        }}</span>
                      </div>
                      <!-- <div class="leftFlex">
                        <span>{{
                          item2.SELLOUT_TARGET_VALUE2 | NumFormat
                        }}</span>
                      </div> -->
                      <div class="leftFlex">
                        <span>{{ item2.SELLOUT_BTG1 | NumFormat }}</span>
                      </div>

                      <div class="leftFlex">
                        <span
                          >{{
                            (weekPatternFlag == true
                              ? item2.weekPatternSellout * 100
                              : item2.timeGoneSellout * 100) | NumFormat
                          }}%</span
                        >
                      </div>
                      <!-- <div class="leftFlex">
                        <span>{{ item2.SELLOUT_BTG2 | NumFormat }}</span>
                      </div> -->
                      <!-- <div class="leftFlex vsProgress">
                    
                        <span>
                          <p
                            :class="
                              parseFloat(item2.SELLOUT_VS_LY) <
                                typeValue.timeGoneSellout * 100 &&
                              parseFloat(item2.SELLOUT_VS_LY) >
                                typeValue.timeGoneSellout * 100 - 5
                                ? 'pinCol'
                                : parseFloat(item2.SELLOUT_VS_LY) >=
                                  typeValue.timeGoneSellout * 100
                                ? 'helthyCol'
                                : 'noticeCol'
                            "
                            :style="
                              'width:' +
                              (parseFloat(item2.SELLOUT_VS_LY) >= 100
                                ? '97%'
                                : item2.SELLOUT_VS_LY)
                            "
                          >
                            {{
                              item2.SELLOUT_VS_LY == ""
                                ? 0 + "%"
                                : item2.SELLOUT_VS_LY
                            }}
                          </p>
                        </span>
                      </div> -->
                    </div>
                  </van-col>

                  <van-col span="7">
                    <div class="proBoxsRight">
                      <div class="tableLeft progressBox">
                        <div class="tabMid">
                          <b :class="item2.outClass11">
                            {{ item2.SELLOUT_SALES_VALUE | NumFormat }}
                          </b>
                        </div>
                        <div
                          class="progress"
                          style="display: flex; flex-direction: column"
                        >
                          <span>
                            <p
                              :class="item2.outClass1"
                              :style="'width:' + item2.outWidth1"
                            >
                              {{
                                item2.SELLOUT_SALES_VALUE == 0 ||
                                item2.SELLOUT_TARGET_VALUE1 == 0
                                  ? 0 + "%"
                                  : (
                                      (item2.SELLOUT_SALES_VALUE /
                                        item2.SELLOUT_TARGET_VALUE1) *
                                      100
                                    ).toFixed(1) + "%"
                              }}
                            </p>
                          </span>
                          <!-- <div class="textTitle">VS RBP</div> -->
                        </div>
                        <!-- <div class="progress"  style="display: flex; flex-direction: column">
                          <span>
                            <p
                              :class="item2.outClass2"
                              :style="'width:' + item2.outWidth2"
                            >
                              {{
                                item2.SELLOUT_SALES_VALUE == 0 ||
                                item2.SELLOUT_TARGET_VALUE2 == 0
                                  ? 0 + "%"
                                  : (
                                      (item2.SELLOUT_SALES_VALUE /
                                        item2.SELLOUT_TARGET_VALUE2) *
                                      100
                                    ).toFixed(1) + "%"
                              }}
                            </p>
                          </span>
                          <div class="textTitle">VS MMF</div>
                        </div> -->
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </van-col>

              <van-col span="2">
                <div class="red" @click.stop="changeBrandThr($event)">
                  <img src="../../../assets/jpg/icon-tag1.svg" alt="" />
                </div>
              </van-col>
            </van-row>
            <!-- Brand List3 start-->
            <div
              class="BrandThrTie"
              v-show="brand3"
              v-for="brandItem2 in item2.level3ByBrandList"
              :key="brandItem2.brandCd"
            >
              <van-row
                type="flex"
                justify="center"
                class="BrandThrTie TwoTie"
                style="background: rgb(246, 246, 255)"
              >
                <van-col span="2"> </van-col>

                <van-col span="20">
                  <van-row span="24">
                    <div class="title">
                      {{ brandItem2.brandCd }}
                    </div>
                  </van-row>

                  <van-row>
                    <van-col span="7">
                      <div class="proBoxsLeft">
                        <div class="tableLeft progressBox">
                          <div class="tabMid">
                            <b :class="brandItem2.inClass11">
                              {{ brandItem2.SELLIN_SALES_VALUE | NumFormat }}
                            </b>
                          </div>
                          <div
                            class="progress"
                            style="display: flex; flex-direction: column"
                          >
                            <span>
                              <p
                                :class="brandItem2.inClass1"
                                :style="'width:' + brandItem2.inWidth1"
                              >
                                {{
                                  brandItem2.SELLIN_SALES_VALUE == 0 ||
                                  brandItem2.SELLIN_TARGET_VALUE1 == 0
                                    ? 0 + "%"
                                    : (
                                        (brandItem2.SELLIN_SALES_VALUE /
                                          brandItem2.SELLIN_TARGET_VALUE1) *
                                        100
                                      ).toFixed(1) + "%"
                                }}
                              </p>
                            </span>

                            <!-- <div class="textTitle">VS RBP</div> -->
                          </div>

                          <!-- <div class="progress" style="display: flex; flex-direction: column">
                          
                            <span>
                              <p
                                :class="brandItem2.inClass2"
                                :style="'width:' + brandItem2.inWidth2"
                              >
                                {{
                                  brandItem2.SELLIN_SALES_VALUE == 0 ||
                                  brandItem2.SELLIN_TARGET_VALUE2 == 0
                                    ? 0 + "%"
                                    : (
                                        (brandItem2.SELLIN_SALES_VALUE /
                                          brandItem2.SELLIN_TARGET_VALUE2) *
                                        100
                                      ).toFixed(1) + "%"
                                }}
                              </p>
                            </span>


                            
                      <div class="textTitle">VS MMF</div>
                          </div> -->
                        </div>
                      </div>
                    </van-col>

                    <van-col span="3">
                      <div
                        class="tableRight middleContentCenter"
                        style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                      >
                        <div class="rightFlex">
                          <span>{{
                            brandItem2.SELLIN_TARGET_VALUE1 | NumFormat
                          }}</span>
                        </div>

                        <!-- <div class="rightFlex">
                          <span>{{
                            brandItem2.SELLIN_TARGET_VALUE2 | NumFormat
                          }}</span>
                        </div> -->

                        <div class="rightFlex">
                          <span>{{ brandItem2.SELLIN_BTG1 | NumFormat }}</span>
                        </div>

                        <div class="rightFlex">
                          <span
                            >{{
                              (weekPatternFlag == true
                                ? brandItem2.weekPattern * 100
                                : brandItem2.timeGone * 100) | NumFormat
                            }}%</span
                          >
                        </div>

                        <!-- <div class="rightFlex">
                          <span>{{ brandItem2.SELLIN_BTG2 | NumFormat }}</span>
                        </div> -->

                        <!-- <div class="rightFlex vsProgress">
                      
                          <span>
                            <p
                              :class="
                                parseFloat(brandItem2.SELLIN_VS_LY) <
                                  typeValue.timeGone * 100 &&
                                parseFloat(brandItem2.SELLIN_VS_LY) >
                                  typeValue.timeGone * 100 - 5
                                  ? 'pinCol'
                                  : parseFloat(brandItem2.SELLIN_VS_LY) >=
                                    typeValue.timeGone * 100
                                  ? 'helthyCol'
                                  : 'noticeCol'
                              "
                              :style="
                                'width:' +
                                (parseFloat(brandItem2.SELLIN_VS_LY) >= 100
                                  ? '97%'
                                  : brandItem2.SELLIN_VS_LY)
                              "
                            >
                              {{
                                brandItem2.SELLIN_VS_LY == ""
                                  ? 0 + "%"
                                  : brandItem2.SELLIN_VS_LY
                              }}
                            </p>
                          </span>
                        </div> -->
                      </div>
                    </van-col>

                    <van-col span="4">
                      <div
                        class="tableCenter middleContentCenter"
                        style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                      >
                        <div class="centerFlex">{{ type1 }}</div>
                        <!-- <div class="centerFlex">{{ type2 }}</div> -->
                        <div class="centerFlex">{{ type3 }}</div>
                        <!-- <div class="centerFlex">{{ type4 }}</div> -->

                        <!-- <div class="centerFlex" style="visibility:hidden">
                          vs.LY
                        </div> -->
                        <div class="centerFlex">{{ type5 }}</div>
                      </div>
                    </van-col>

                    <van-col span="3">
                      <div class="tableLeft middleContentCenter">
                        <div class="leftFlex">
                          <span>{{
                            brandItem2.SELLOUT_TARGET_VALUE1 | NumFormat
                          }}</span>
                        </div>

                        <!-- <div class="leftFlex">
                          <span>{{
                            brandItem2.SELLOUT_TARGET_VALUE2 | NumFormat
                          }}</span>
                        </div> -->

                        <div class="leftFlex">
                          <span>{{ brandItem2.SELLOUT_BTG1 | NumFormat }}</span>
                        </div>

                        <div class="leftFlex">
                          <span
                            >{{
                              (weekPatternFlag == true
                                ? brandItem2.weekPatternSellout * 100
                                : brandItem2.timeGoneSellout * 100) | NumFormat
                            }}%</span
                          >
                        </div>

                        <!-- <div class="leftFlex">
                          <span>{{ brandItem2.SELLOUT_BTG2 | NumFormat }}</span>
                        </div> -->

                        <!-- <div class="leftFlex vsProgress">
                      
                          <span>
                            <p
                              :class="
                                parseFloat(brandItem2.SELLOUT_VS_LY) <
                                  typeValue.timeGoneSellout * 100 &&
                                parseFloat(brandItem2.SELLOUT_VS_LY) >
                                  typeValue.timeGoneSellout * 100 - 5
                                  ? 'pinCol'
                                  : parseFloat(brandItem2.SELLOUT_VS_LY) >=
                                    typeValue.timeGoneSellout * 100
                                  ? 'helthyCol'
                                  : 'noticeCol'
                              "
                              :style="
                                'width:' +
                                (parseFloat(brandItem2.SELLOUT_VS_LY) >= 100
                                  ? '97%'
                                  : brandItem2.SELLOUT_VS_LY)
                              "
                            >
                              {{
                                brandItem2.SELLOUT_VS_LY == ""
                                  ? 0 + "%"
                                  : brandItem2.SELLOUT_VS_LY
                              }}
                            </p>
                          </span>
                        </div> -->
                      </div>
                    </van-col>

                    <van-col span="7">
                      <div class="proBoxsRight">
                        <div class="tableLeft progressBox">
                          <div class="tabMid">
                            <b :class="brandItem2.outClass11">
                              {{ brandItem2.SELLOUT_SALES_VALUE | NumFormat }}
                            </b>
                          </div>
                          <div
                            class="progress"
                            style="display: flex; flex-direction: column"
                          >
                            <span>
                              <p
                                :class="brandItem2.outClass1"
                                :style="'width:' + brandItem2.outWidth1"
                              >
                                {{
                                  brandItem2.SELLOUT_SALES_VALUE == 0 ||
                                  brandItem2.SELLOUT_TARGET_VALUE1 == 0
                                    ? 0 + "%"
                                    : (
                                        (brandItem2.SELLOUT_SALES_VALUE /
                                          brandItem2.SELLOUT_TARGET_VALUE1) *
                                        100
                                      ).toFixed(1) + "%"
                                }}
                              </p>
                            </span>

                            <!-- <div class="textTitle">VS RBP</div> -->
                          </div>

                          <!-- <div class="progress"    style="display: flex; flex-direction: column">
                            <span>
                              <p
                                :class="brandItem2.outClass2"
                                :style="'width:' + brandItem2.outWidth2"
                              >
                                {{
                                  brandItem2.SELLOUT_SALES_VALUE == 0 ||
                                  brandItem2.SELLOUT_TARGET_VALUE2 == 0
                                    ? 0 + "%"
                                    : (
                                        (brandItem2.SELLOUT_SALES_VALUE /
                                          brandItem2.SELLOUT_TARGET_VALUE2) *
                                        100
                                      ).toFixed(1) + "%"
                                }}
                              </p>
                            </span>
                            <div class="textTitle">VS MMF</div>
                          </div> -->
                        </div>
                      </div>
                    </van-col>
                  </van-row>
                </van-col>

                <van-col span="2"> </van-col>
              </van-row>
            </div>
            <!-- Brand List3 end-->

            <div
              class="channelThr"
              v-show="channel3"
              v-for="channel3Item in item2.levelList4"
              :key="channel3Item.level4"
            >
              <van-row
                type="flex"
                justify="center"
                class="channelThr TwoTie"
                style="
                  background: rgb(255, 255, 255);
                  border-bottom: 2px solid #ccc;
                "
                @click.stop="changeChannelFif($event)"
              >
                <van-col span="2"> 
                  <div class="redPlus" v-show="channel3Item.levelList5.length > 0">
                  <img
                    src="../../../assets/jpg/icon-3-right.svg"
                    style="width: 18px; height: 18px"
                    alt
                  />
                </div>

                </van-col>

                <van-col span="20">
                  <van-row>
                    <van-col span="24">
                      <div class="title">
                        {{ channel3Item.level4 }}
                      </div>
                    </van-col>
                  </van-row>

                  <van-row>
                    <van-col span="7">
                      <div class="proBoxsLeft">
                        <div class="tableLeft progressBox">
                          <div class="tabMid">
                            <b :class="channel3Item.inClass11">
                              {{ channel3Item.SELLIN_SALES_VALUE | NumFormat }}
                            </b>
                          </div>
                          <div
                            class="progress"
                            style="display: flex; flex-direction: column"
                          >
                            <span>
                              <p
                                :class="channel3Item.inClass1"
                                :style="'width:' + channel3Item.inWidth1"
                              >
                                {{
                                  channel3Item.SELLIN_SALES_VALUE == 0 ||
                                  channel3Item.SELLIN_TARGET_VALUE1 == 0
                                    ? 0 + "%"
                                    : (
                                        (channel3Item.SELLIN_SALES_VALUE /
                                          channel3Item.SELLIN_TARGET_VALUE1) *
                                        100
                                      ).toFixed(1) + "%"
                                }}
                              </p>
                            </span>

                            <!-- <div class="textTitle">VS RBP</div> -->
                          </div>

                          <!-- <div class="progress"      style="display: flex; flex-direction: column">
                       
                            <span>
                              <p
                                :class="channel3Item.inClass2"
                                :style="'width:' + channel3Item.inWidth2"
                              >
                                {{
                                  channel3Item.SELLIN_SALES_VALUE == 0 ||
                                  channel3Item.SELLIN_TARGET_VALUE2 == 0
                                    ? 0 + "%"
                                    : (
                                        (channel3Item.SELLIN_SALES_VALUE /
                                          channel3Item.SELLIN_TARGET_VALUE2) *
                                        100
                                      ).toFixed(1) + "%"
                                }}
                              </p>
                            </span>


                            <div class="textTitle">VS MMF</div>
                          </div> -->
                        </div>
                      </div>
                    </van-col>

                    <van-col span="3">
                      <div
                        class="tableRight middleContentCenter"
                        style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                      >
                        <div class="rightFlex">
                          <span>{{
                            channel3Item.SELLIN_TARGET_VALUE1 | NumFormat
                          }}</span>
                        </div>
                        <!-- <div class="rightFlex">
                          <span>{{
                            channel3Item.SELLIN_TARGET_VALUE2 | NumFormat
                          }}</span>
                        </div> -->
                        <div class="rightFlex">
                          <span>{{
                            channel3Item.SELLIN_BTG1 | NumFormat
                          }}</span>
                        </div>

                        <div class="rightFlex">
                          <span
                            >{{
                              (weekPatternFlag == true
                                ? channel3Item.weekPattern * 100
                                : channel3Item.timeGone * 100) | NumFormat
                            }}%</span
                          >
                        </div>

                        <!-- <div class="rightFlex">
                          <span>{{
                            channel3Item.SELLIN_BTG2 | NumFormat
                          }}</span>
                        </div> -->

                        <!-- <div class="rightFlex vsProgress">
                     
                          <span>
                            <p
                              :class="
                                parseFloat(channel3Item.SELLIN_VS_LY) <
                                  typeValue.timeGone * 100 &&
                                parseFloat(channel3Item.SELLIN_VS_LY) >
                                  typeValue.timeGone * 100 - 5
                                  ? 'pinCol'
                                  : parseFloat(channel3Item.SELLIN_VS_LY) >=
                                    typeValue.timeGone * 100
                                  ? 'helthyCol'
                                  : 'noticeCol'
                              "
                              :style="
                                'width:' +
                                (parseFloat(channel3Item.SELLIN_VS_LY) >= 100
                                  ? '97%'
                                  : channel3Item.SELLIN_VS_LY)
                              "
                            >
                              {{
                                channel3Item.SELLIN_VS_LY == ""
                                  ? 0 + "%"
                                  : channel3Item.SELLIN_VS_LY
                              }}
                            </p>
                          </span>
                        </div> -->
                      </div>
                    </van-col>

                    <van-col span="4">
                      <div
                        class="tableCenter middleContentCenter"
                        style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                      >
                        <div class="centerFlex">{{ type1 }}</div>
                        <!-- <div class="centerFlex">{{ type2 }}</div> -->
                        <div class="centerFlex">{{ type3 }}</div>
                        <!-- <div class="centerFlex">{{ type4 }}</div> -->
                        <!-- <div class="centerFlex" style="visibility:hidden">
                          vs.LY
                        </div> -->
                        <div class="centerFlex">{{ type5 }}</div>
                      </div>
                    </van-col>

                    <van-col span="3">
                      <div class="tableLeft middleContentCenter">
                        <div class="leftFlex">
                          <span>{{
                            channel3Item.SELLOUT_TARGET_VALUE1 | NumFormat
                          }}</span>
                        </div>
                        <!-- <div class="leftFlex">
                          <span>{{
                            channel3Item.SELLOUT_TARGET_VALUE2 | NumFormat
                          }}</span>
                        </div> -->

                        <div class="leftFlex">
                          <span>{{
                            channel3Item.SELLOUT_BTG1 | NumFormat
                          }}</span>
                        </div>

                        <div class="leftFlex">
                          <span
                            >{{
                              (weekPatternFlag == true
                                ? channel3Item.weekPatternSellout * 100
                                : channel3Item.timeGoneSellout * 100) | NumFormat
                            }}%</span
                          >
                        </div>

                        <!-- <div class="leftFlex">
                          <span>{{
                            channel3Item.SELLOUT_BTG2 | NumFormat
                          }}</span>
                        </div> -->

                        <!-- <div class="leftFlex vsProgress">
                    
                          <span>
                            <p
                              :class="
                                parseFloat(channel3Item.SELLOUT_VS_LY) <
                                  typeValue.timeGoneSellout * 100 &&
                                parseFloat(channel3Item.SELLOUT_VS_LY) >
                                  typeValue.timeGoneSellout * 100 - 5
                                  ? 'pinCol'
                                  : parseFloat(channel3Item.SELLOUT_VS_LY) >=
                                    typeValue.timeGoneSellout * 100
                                  ? 'helthyCol'
                                  : 'noticeCol'
                              "
                              :style="
                                'width:' +
                                (parseFloat(channel3Item.SELLOUT_VS_LY) >= 100
                                  ? '97%'
                                  : channel3Item.SELLOUT_VS_LY)
                              "
                            >
                              {{
                                channel3Item.SELLOUT_VS_LY == ""
                                  ? 0 + "%"
                                  : channel3Item.SELLOUT_VS_LY
                              }}
                            </p>
                          </span>
                        </div> -->
                      </div>
                    </van-col>

                    <van-col span="7">
                      <div class="proBoxsRight">
                        <div class="tableLeft progressBox">
                          <div class="tabMid">
                            <b :class="channel3Item.outClass11">
                              {{ channel3Item.SELLOUT_SALES_VALUE | NumFormat }}
                            </b>
                          </div>
                          <div class="progress">
                            <span>
                              <p
                                :class="channel3Item.outClass1"
                                :style="'width:' + channel3Item.outWidth1"
                              >
                                {{
                                  channel3Item.SELLOUT_SALES_VALUE == 0 ||
                                  channel3Item.SELLOUT_TARGET_VALUE1 == 0
                                    ? 0 + "%"
                                    : (
                                        (channel3Item.SELLOUT_SALES_VALUE /
                                          channel3Item.SELLOUT_TARGET_VALUE1) *
                                        100
                                      ).toFixed(1) + "%"
                                }}
                              </p>
                            </span>

                            <!-- <div class="textTitle">VS RBP</div> -->
                          </div>

                          <!-- <div class="progress" style="display: flex; flex-direction: column">
                            <span>
                              <p
                                :class="channel3Item.outClass2"
                                :style="'width:' + channel3Item.outWidth2"
                              >
                                {{
                                  channel3Item.SELLOUT_SALES_VALUE == 0 ||
                                  channel3Item.SELLOUT_TARGET_VALUE2 == 0
                                    ? 0 + "%"
                                    : (
                                        (channel3Item.SELLOUT_SALES_VALUE /
                                          channel3Item.SELLOUT_TARGET_VALUE2) *
                                        100
                                      ).toFixed(1) + "%"
                                }}
                              </p>
                            </span>
                            <div class="textTitle"> VS MMF </div>
                          </div> -->
                        </div>
                      </div>
                    </van-col>
                  </van-row>
                </van-col>

                <van-col
                  span="2"
                  v-if="channel3Item.level4ByBrandList.length >= 1"
                >
                  <div class="red" @click.stop="changeBrandFor($event)">
                    <img src="../../../assets/jpg/icon-tag1.svg" alt="" />
                  </div>
                </van-col>
              </van-row>
              <!-- Brand List4 start -->
              <div
                class="BrandForTie"
                v-show="brand4"
                v-for="brandItem3 in channel3Item.level4ByBrandList"
                :key="brandItem3.brandCd"
              >
                <van-row
                  type="flex"
                  justify="center"
                  class="BrandForTie"
                  style="background-color: rgb(246, 246, 255)"
                >
                  <van-col span="2" type="flex"> </van-col>

                  <van-col span="20" type="flex">
                    <van-row>
                      <van-col span="24">
                        <div class="title">
                          {{ brandItem3.brandCd }}
                        </div>
                      </van-col>
                    </van-row>

                    <van-row>
                      <van-col span="7">
                        <div class="proBoxsLeft">
                          <div class="tableLeft progressBox">
                            <div class="tabMid">
                              <b :class="brandItem3.inClass11">
                                {{ brandItem3.SELLIN_SALES_VALUE | NumFormat }}
                              </b>
                            </div>
                            <div
                              class="progress"
                              style="display: flex; flex-direction: column"
                            >
                              <span>
                                <p
                                  :class="brandItem3.inClass1"
                                  :style="
                                    'width:' +
                                    brandItem3.SELLIN_TARGET_VALUE1_ACHEVE
                                  "
                                >
                                  {{
                                    brandItem3.SELLIN_SALES_VALUE == 0 ||
                                    brandItem3.SELLIN_TARGET_VALUE1 == 0
                                      ? 0 + "%"
                                      : (
                                          (brandItem3.SELLIN_SALES_VALUE /
                                            brandItem3.SELLIN_TARGET_VALUE1) *
                                          100
                                        ).toFixed(1) + "%"
                                  }}
                                </p>
                              </span>

                              <!-- <div class="textTitle">VS RBP</div> -->
                            </div>

                            <!-- <div class="progress" style="display: flex; flex-direction: column">
                         
                              <span>
                                <p
                                  :class="brandItem3.inClass2"
                                  :style="'width:' + brandItem3.inWidth2"
                                >
                                  {{
                                    brandItem3.SELLIN_SALES_VALUE == 0 ||
                                    brandItem3.SELLIN_TARGET_VALUE2 == 0
                                      ? 0 + "%"
                                      : (
                                          (brandItem3.SELLIN_SALES_VALUE /
                                            brandItem3.SELLIN_TARGET_VALUE2) *
                                          100
                                        ).toFixed(1) + "%"
                                  }}
                                </p>
                              </span>
                              <div class="textTitle"> VS MMF </div>
                            </div> -->
                          </div>
                        </div>
                      </van-col>

                      <van-col span="3">
                        <div
                          class="tableRight middleContentCenter"
                          style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                        >
                          <div class="rightFlex">
                            <span>{{
                              brandItem3.SELLIN_TARGET_VALUE1 | NumFormat
                            }}</span>
                          </div>
                          <!-- <div class="rightFlex">
                            <span>{{
                              brandItem3.SELLIN_TARGET_VALUE2 | NumFormat
                            }}</span>
                          </div> -->

                          <div class="rightFlex">
                            <span>{{
                              brandItem3.SELLIN_BTG1 | NumFormat
                            }}</span>
                          </div>

                          <div class="rightFlex">
                            <span
                              >{{
                                (weekPatternFlag == true
                                  ? brandItem3.weekPattern * 100
                                  : brandItem3.timeGone * 100) | NumFormat
                              }}%</span
                            >
                          </div>

                          <!-- <div class="rightFlex">
                            <span>{{
                              brandItem3.SELLIN_BTG2 | NumFormat
                            }}</span>
                          </div> -->

                          <!-- <div class="rightFlex vsProgress">
                      
                            <span>
                              <p
                                :class="
                                  parseFloat(brandItem3.SELLIN_VS_LY) <
                                    typeValue.timeGone * 100 &&
                                  parseFloat(brandItem3.SELLIN_VS_LY) >
                                    typeValue.timeGone * 100 - 5
                                    ? 'pinCol'
                                    : parseFloat(brandItem3.SELLIN_VS_LY) >=
                                      typeValue.timeGone * 100
                                    ? 'helthyCol'
                                    : 'noticeCol'
                                "
                                :style="
                                  'width:' +
                                  (parseFloat(brandItem3.SELLIN_VS_LY) >= 100
                                    ? '97%'
                                    : brandItem3.SELLIN_VS_LY)
                                "
                              >
                                {{
                                  brandItem3.SELLIN_VS_LY == ""
                                    ? 0 + "%"
                                    : brandItem3.SELLIN_VS_LY
                                }}
                              </p>
                            </span>
                          </div> -->
                        </div>
                      </van-col>

                      <van-col span="4">
                        <div
                          class="tableCenter middleContentCenter"
                          style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                        >
                          <div class="centerFlex">{{ type1 }}</div>
                          <!-- <div class="centerFlex">{{ type2 }}</div> -->
                          <div class="centerFlex">{{ type3 }}</div>
                          <!-- <div class="centerFlex">{{ type4 }}</div> -->

                          <!-- <div class="centerFlex" style="visibility:hidden">
                            vs.LY
                          </div> -->
                          <div class="centerFlex">{{ type5 }}</div>
                        </div>
                      </van-col>

                      <van-col span="3">
                        <div class="tableLeft middleContentCenter">
                          <div class="leftFlex">
                            <span>{{
                              brandItem3.SELLOUT_TARGET_VALUE1 | NumFormat
                            }}</span>
                          </div>

                          <!-- <div class="leftFlex">
                            <span>{{
                              brandItem3.SELLOUT_TARGET_VALUE2 | NumFormat
                            }}</span>
                          </div> -->

                          <div class="leftFlex">
                            <span>{{
                              brandItem3.SELLOUT_BTG1 | NumFormat
                            }}</span>
                          </div>

                          <div class="leftFlex">
                            <span
                              >{{
                                (weekPatternFlag == true
                                  ? brandItem3.weekPatternSellout * 100
                                  : brandItem3.timeGoneSellout * 100) | NumFormat
                              }}%</span
                            >
                          </div>

                          <!-- <div class="leftFlex">
                            <span>{{
                              brandItem3.SELLOUT_BTG2 | NumFormat
                            }}</span>
                          </div> -->

                          <!-- <div class="leftFlex vsProgress">
                      
                            <span>
                              <p
                                :class="
                                  parseFloat(brandItem3.SELLOUT_VS_LY) <
                                    typeValue.timeGoneSellout * 100 &&
                                  parseFloat(brandItem3.SELLOUT_VS_LY) >
                                    typeValue.timeGoneSellout * 100 - 5
                                    ? 'pinCol'
                                    : parseFloat(brandItem3.SELLOUT_VS_LY) >=
                                      typeValue.timeGoneSellout * 100
                                    ? 'helthyCol'
                                    : 'noticeCol'
                                "
                                :style="
                                  'width:' +
                                  (parseFloat(brandItem3.SELLOUT_VS_LY) >= 100
                                    ? '97%'
                                    : brandItem3.SELLOUT_VS_LY)
                                "
                              >
                                {{
                                  brandItem3.SELLOUT_VS_LY == ""
                                    ? 0 + "%"
                                    : brandItem3.SELLOUT_VS_LY
                                }}
                              </p>
                            </span>
                          </div> -->
                        </div>
                      </van-col>

                      <van-col span="7">
                        <div class="proBoxsRight">
                          <div class="tableLeft progressBox">
                            <div class="tabMid">
                              <b :class="brandItem3.outClass11">
                                {{ brandItem3.SELLOUT_SALES_VALUE | NumFormat }}
                              </b>
                            </div>
                            <div
                              class="progress"
                              style="display: flex; flex-direction: column"
                            >
                              <span>
                                <p
                                  :class="brandItem3.outClass1"
                                  :style="'width:' + brandItem3.outWidth1"
                                >
                                  {{
                                    brandItem3.SELLOUT_SALES_VALUE == 0 ||
                                    brandItem3.SELLOUT_TARGET_VALUE1 == 0
                                      ? 0 + "%"
                                      : (
                                          (brandItem3.SELLOUT_SALES_VALUE /
                                            brandItem3.SELLOUT_TARGET_VALUE1) *
                                          100
                                        ).toFixed(1) + "%"
                                  }}
                                </p>
                              </span>

                              <!-- <div class="textTitle">VS RBP</div> -->
                            </div>

                            <!-- <div class="progress" style="display: flex; flex-direction: column">
                              <span>
                                <p
                                  :class="brandItem3.outClass2"
                                  :style="'width:' + brandItem3.outWidth2"
                                >
                                  {{
                                    brandItem3.SELLOUT_SALES_VALUE == 0 ||
                                    brandItem3.SELLOUT_TARGET_VALUE2 == 0
                                      ? 0 + "%"
                                      : (
                                          (brandItem3.SELLOUT_SALES_VALUE /
                                            brandItem3.SELLOUT_TARGET_VALUE2) *
                                          100
                                        ).toFixed(1) + "%"
                                  }}
                                </p>
                              </span>

                      <div class="textTitle"> VS MMF </div>
                            </div> -->
                          </div>
                        </div>
                      </van-col>
                    </van-row>
                  </van-col>

                  <van-col span="2"> </van-col>
                </van-row>
              </div>
              <!-- Brand List4 end -->
              <!-- 新增第五层级 -->
              <div
              class="channelFif"
              v-show="channel4"
              v-for="channel4Item in channel3Item.levelList5"
              :key="channel4Item.level5"
            >
              <van-row
                type="flex"
                justify="center"
                class="channelFif TwoTie"
                style="
                  background: rgb(246, 246, 255);
                  border-bottom: 2px solid #ccc;
                "
              >
                <van-col span="2"> </van-col>

                <van-col span="20">
                  <van-row>
                    <van-col span="24">
                      <div class="title">
                        {{ channel4Item.level5 }}
                      </div>
                    </van-col>
                  </van-row>

                  <van-row>
                    <van-col span="7">
                      <div class="proBoxsLeft">
                        <div class="tableLeft progressBox">
                          <div class="tabMid">
                            <b :class="channel4Item.inClass11">
                              {{ channel4Item.SELLIN_SALES_VALUE | NumFormat }}
                            </b>
                          </div>
                          <div
                            class="progress"
                            style="display: flex; flex-direction: column"
                          >
                            <span>
                              <p
                                :class="channel4Item.inClass1"
                                :style="'width:' + channel4Item.inWidth1"
                              >
                                {{
                                  channel4Item.SELLIN_SALES_VALUE == 0 ||
                                  channel4Item.SELLIN_TARGET_VALUE1 == 0
                                    ? 0 + "%"
                                    : (
                                        (channel4Item.SELLIN_SALES_VALUE /
                                        channel4Item.SELLIN_TARGET_VALUE1) *
                                        100
                                      ).toFixed(1) + "%"
                                }}
                              </p>
                            </span>

                            <!-- <div class="textTitle">VS RBP</div> -->
                          </div>
                        </div>
                      </div>
                    </van-col>

                    <van-col span="3">
                      <div
                        class="tableRight middleContentCenter"
                        style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                      >
                        <div class="rightFlex">
                          <span>{{
                            channel4Item.SELLIN_TARGET_VALUE1 | NumFormat
                          }}</span>
                        </div>
                        <!-- <div class="rightFlex">
                          <span>{{
                            channel3Item.SELLIN_TARGET_VALUE2 | NumFormat
                          }}</span>
                        </div> -->
                        <div class="rightFlex">
                          <span>{{
                            channel4Item.SELLIN_BTG1 | NumFormat
                          }}</span>
                        </div>

                        <div class="rightFlex">
                          <span
                            >{{
                              (weekPatternFlag == true
                                ? channel4Item.weekPattern * 100
                                : channel4Item.timeGone * 100) | NumFormat
                            }}%</span
                          >
                        </div>
                      </div>
                    </van-col>

                    <van-col span="4">
                      <div
                        class="tableCenter middleContentCenter"
                        style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                      >
                        <div class="centerFlex">{{ type1 }}</div>
                        <!-- <div class="centerFlex">{{ type2 }}</div> -->
                        <div class="centerFlex">{{ type3 }}</div>
                        <div class="centerFlex">{{ type5 }}</div>
                      </div>
                    </van-col>

                    <van-col span="3">
                      <div class="tableLeft middleContentCenter">
                        <div class="leftFlex">
                          <span>{{
                            channel4Item.SELLOUT_TARGET_VALUE1 | NumFormat
                          }}</span>
                        </div>

                        <div class="leftFlex">
                          <span>{{
                            channel4Item.SELLOUT_BTG1 | NumFormat
                          }}</span>
                        </div>

                        <div class="leftFlex">
                          <span
                            >{{
                              (weekPatternFlag == true
                                ? channel4Item.weekPatternSellout * 100
                                : channel4Item.timeGoneSellout * 100) | NumFormat
                            }}%</span
                          >
                        </div>
                      </div>
                    </van-col>

                    <van-col span="7">
                      <div class="proBoxsRight">
                        <div class="tableLeft progressBox">
                          <div class="tabMid">
                            <b :class="channel4Item.outClass11">
                              {{ channel4Item.SELLOUT_SALES_VALUE | NumFormat }}
                            </b>
                          </div>
                          <div class="progress">
                            <span>
                              <p
                                :class="channel4Item.outClass1"
                                :style="'width:' + channel4Item.outWidth1"
                              >
                                {{
                                  channel4Item.SELLOUT_SALES_VALUE == 0 ||
                                  channel4Item.SELLOUT_TARGET_VALUE1 == 0
                                    ? 0 + "%"
                                    : (
                                        (channel4Item.SELLOUT_SALES_VALUE /
                                        channel4Item.SELLOUT_TARGET_VALUE1) *
                                        100
                                      ).toFixed(1) + "%"
                                }}
                              </p>
                            </span>

                            <!-- <div class="textTitle">VS RBP</div> -->
                          </div>
                        </div>
                      </div>
                    </van-col>
                  </van-row>
                </van-col>

                <van-col
                  span="2"
                  v-if="channel4Item.level5ByBrandList.length >= 1"
                >
                  <div class="red" @click.stop="changeBrandFif($event)">
                    <img src="../../../assets/jpg/icon-tag1.svg" alt="" />
                  </div>
                </van-col>
              </van-row>
              <!-- Brand List5 start -->
              <div
                class="BrandFifTie"
                v-show="brand5"
                v-for="brandItem4 in channel4Item.level5ByBrandList"
                :key="brandItem4.brandCd"
              >
                <van-row
                  type="flex"
                  justify="center"
                  class="BrandFifTie"
                  style="background-color: rgb(246, 246, 255)"
                >
                  <van-col span="2" type="flex"> </van-col>

                  <van-col span="20" type="flex">
                    <van-row>
                      <van-col span="24">
                        <div class="title">
                          {{ brandItem4.brandCd }}
                        </div>
                      </van-col>
                    </van-row>

                    <van-row>
                      <van-col span="7">
                        <div class="proBoxsLeft">
                          <div class="tableLeft progressBox">
                            <div class="tabMid">
                              <b :class="brandItem4.inClass11">
                                {{ brandItem4.SELLIN_SALES_VALUE | NumFormat }}
                              </b>
                            </div>
                            <div
                              class="progress"
                              style="display: flex; flex-direction: column"
                            >
                              <span>
                                <p
                                  :class="brandItem4.inClass1"
                                  :style="
                                    'width:' +
                                    brandItem4.SELLIN_TARGET_VALUE1_ACHEVE
                                  "
                                >
                                  {{
                                    brandItem4.SELLIN_SALES_VALUE == 0 ||
                                    brandItem4.SELLIN_TARGET_VALUE1 == 0
                                      ? 0 + "%"
                                      : (
                                          (brandItem4.SELLIN_SALES_VALUE /
                                          brandItem4.SELLIN_TARGET_VALUE1) *
                                          100
                                        ).toFixed(1) + "%"
                                  }}
                                </p>
                              </span>

                              <!-- <div class="textTitle">VS RBP</div> -->
                            </div>
                          </div>
                        </div>
                      </van-col>

                      <van-col span="3">
                        <div
                          class="tableRight middleContentCenter"
                          style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                        >
                          <div class="rightFlex">
                            <span>{{
                              brandItem4.SELLIN_TARGET_VALUE1 | NumFormat
                            }}</span>
                          </div>

                          <div class="rightFlex">
                            <span>{{
                              brandItem4.SELLIN_BTG1 | NumFormat
                            }}</span>
                          </div>

                          <div class="rightFlex">
                            <span
                              >{{
                                (weekPatternFlag == true
                                  ? brandItem4.weekPattern * 100
                                  : brandItem4.timeGone * 100) | NumFormat
                              }}%</span
                            >
                          </div>
                        </div>
                      </van-col>

                      <van-col span="4">
                        <div
                          class="tableCenter middleContentCenter"
                          style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                        >
                          <div class="centerFlex">{{ type1 }}</div>
                          <div class="centerFlex">{{ type3 }}</div>
                          <div class="centerFlex">{{ type5 }}</div>
                        </div>
                      </van-col>

                      <van-col span="3">
                        <div class="tableLeft middleContentCenter">
                          <div class="leftFlex">
                            <span>{{
                              brandItem4.SELLOUT_TARGET_VALUE1 | NumFormat
                            }}</span>
                          </div>

                          <div class="leftFlex">
                            <span>{{
                              brandItem4.SELLOUT_BTG1 | NumFormat
                            }}</span>
                          </div>

                          <div class="leftFlex">
                            <span
                              >{{
                                (weekPatternFlag == true
                                  ? brandItem4.weekPatternSellout * 100
                                  : brandItem4.timeGoneSellout * 100) | NumFormat
                              }}%</span
                            >
                          </div>
                        </div>
                      </van-col>

                      <van-col span="7">
                        <div class="proBoxsRight">
                          <div class="tableLeft progressBox">
                            <div class="tabMid">
                              <b :class="brandItem4.outClass11">
                                {{ brandItem4.SELLOUT_SALES_VALUE | NumFormat }}
                              </b>
                            </div>
                            <div
                              class="progress"
                              style="display: flex; flex-direction: column"
                            >
                              <span>
                                <p
                                  :class="brandItem4.outClass1"
                                  :style="'width:' + brandItem4.outWidth1"
                                >
                                  {{
                                    brandItem4.SELLOUT_SALES_VALUE == 0 ||
                                    brandItem4.SELLOUT_TARGET_VALUE1 == 0
                                      ? 0 + "%"
                                      : (
                                          (brandItem4.SELLOUT_SALES_VALUE /
                                          brandItem4.SELLOUT_TARGET_VALUE1) *
                                          100
                                        ).toFixed(1) + "%"
                                  }}
                                </p>
                              </span>
                              <!-- <div class="textTitle">VS RBP</div> -->
                            </div>
                          </div>
                        </div>
                      </van-col>
                    </van-row>
                  </van-col>

                  <van-col span="2"> </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </div>
          <van-row
            type="flex"
            justify="center"
            v-show="isShow2"
            class="TwoTieAct"
            v-if="item1.levelList3Map && item1.levelList3Map.length > 1"
          >
            <van-col span="7">
              <van-row
                v-for="item3 in item1.levelList3Map"
                :key="item3.karegionplatform"
              >
                <div class="list" v-if="item3.karegionplatform != 'Mid'">
                  <b>{{
                    item3.karegionplatform == "Mid"
                      ? "Central"
                      : item3.karegionplatform
                  }}</b>
                  <span>{{ item3.salesValue | NumFormat }}</span>
                </div>
              </van-row>
            </van-col>
            <van-col span="12" :class="item1.level2">
              <Mymap :binId="item1.level2" :areaList="MapList"></Mymap>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import qs from "qs";
import "echarts/map/js/china.js";
import Mymap from "@/components/ButSecoend/Public/Map";

export default {
  data() {
    return {
      type1: "",
      type2: "",
      type3: "",
      type4: "",
      type5: "",

      typeValue: {},

      isShow: true,
      isShow2: false,
      tableList: [],
      MapList: [],
      MapData: [],
      isBtn: true,
      isBtn2: true,
      achVing: sessionStorage.getItem("achVing"),
      showDate: false,
      brand1: false,
      brand2: false,
      brand3: false,
      brand4: false,
      brand5: false,
      channel3: false,
      channel4: false,
      type: "",

      weekPatternFlag: false,
    };
  },
  methods: {
    getWidthPercent(value) {
      if ((value * 100).toFixed(1) >= 100) {
        return "97%";
      } else {
        return (value * 100).toFixed(1) + "%";
      }
    },

    getDataClass(a, b, c) {
      if (b !== 0) {
        if (a / b > 1) {
          return "helthy"; //绿色
        } else if (a / b < 0.8) {
          return "notice"; //红色
        } else {
          return "pin"; //黄色
        }
      } else {
        if (a / c > 1) {
          return "helthy"; //绿色
        } else if (a / c < 0.8) {
          return "notice"; //红色
        } else {
          return "pin"; //黄色
        }
      }
    },

    getDataClassTitle(a, b, c) {
      if (b !== 0) {
        if (a / b > 1) {
          return "helthyFormat"; //绿色
        } else if (a / b < 0.8) {
          return "noticeFormat"; //红色
        } else {
          return "pinFormat"; //黄色
        }
      } else {
        if (a / c > 1) {
          return "helthyFormat"; //绿色
        } else if (a / c < 0.8) {
          return "noticeFormat"; //红色
        } else {
          return "pinFormat"; //黄色
        }
      }
    },

    changeBrand(e) {
      if (
        $(e.currentTarget).parent().parent().find(".redPlus").attr("class") ==
        "redPlus"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .addClass("redPlusActiveImg");
      } else {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActiveImg");
      }
      if (
        $(e.currentTarget).parent().parent().find(".redPlus").attr("class") ==
        "redPlus redPlusActiveImg redPlusActive"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActiveImg");
      } else {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .addClass("redPlusActiveImg");
      }
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandOneTie")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".ChannelList1")
        .css("display", "none");
    },
    changeBrandTwo(e) {
      if ($(e.currentTarget).attr("class") == "red redActive") {
        $(e.currentTarget).removeClass("redActive");
      } else {
        $(e.currentTarget).addClass("redActive");
      }
      if (
        $(e.currentTarget).parent().parent().find(".redPlus").attr("class") ==
        "redPlus redPlusActive"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActive");
      }
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandTieTie")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".TwoTieAct")
        .css("display", "none");
    },
    changeBrandThr(e) {
      console.log($(e.currentTarget).parent().parent());
      if (
        $(e.currentTarget).parent().parent().find(".redPlus").attr("class") ==
        "redPlus redPlusActive"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActive");
      }
      if ($(e.currentTarget).attr("class") == "red redActive") {
        $(e.currentTarget).removeClass("redActive");
      } else {
        $(e.currentTarget).addClass("redActive");
      }

      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandThrTie")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".channelThr")
        .css("display", "none");

        $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandFifTie")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".channelFif")
        .css("display", "none");
    },

    changeBrandFor(e) {
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandForTie")
        .stop()
        .slideToggle(500);

      if ($(e.currentTarget).attr("class") == "red redActive") {
        $(e.currentTarget).removeClass("redActive");
      } else {
        $(e.currentTarget).addClass("redActive");
      }
    },
    changeBrandFif(e) {
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandFifTie")
        .stop()
        .slideToggle(500);

      if ($(e.currentTarget).attr("class") == "red redActive") {
        $(e.currentTarget).removeClass("redActive");
      } else {
        $(e.currentTarget).addClass("redActive");
      }
    },

    changeChannel(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red redActive") {
        $(e.currentTarget).find(".red").removeClass("redActive");
      }
      if (
        $(e.currentTarget).find(".redPlus").attr("class") ==
        "redPlus redPlusActive"
      ) {
        $(e.currentTarget).find(".redPlus").removeClass("redPlusActive");
      } else {
        $(e.currentTarget).find(".redPlus").addClass("redPlusActive");
      }
      $(e.currentTarget).nextAll(".TwoTieAct").stop().slideToggle(500);
      $(e.currentTarget).nextAll(".BrandOneTie").css("display", "none");
    },

    changeChannelTwo(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red redActive") {
        $(e.currentTarget).find(".red").removeClass("redActive");
      }
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".TwoTieAct")
        .stop()
        .slideToggle(500);
      $(e.currentTarget).nextAll(".BrandTieTie").css("display", "none");
    },
    changeChannelThr(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red redActive") {
        $(e.currentTarget).find(".red").removeClass("redActive");
      }
      if (
        $(e.currentTarget).find(".redPlus").attr("class") ==
        "redPlus redPlusActive"
      ) {
        $(e.currentTarget).find(".redPlus").removeClass("redPlusActive");
      } else {
        $(e.currentTarget).find(".redPlus").addClass("redPlusActive");
      }
      $(e.currentTarget).nextAll(".channelThr").stop().slideToggle(500);

      $(e.currentTarget).nextAll(".BrandThrTie").css("display", "none");
    },
    
    changeChannelFif(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red redActive") {
        $(e.currentTarget).find(".red").removeClass("redActive");
      }
      if (
        $(e.currentTarget).find(".redPlus").attr("class") ==
        "redPlus redPlusActive"
      ) {
        $(e.currentTarget).find(".redPlus").removeClass("redPlusActive");
      } else {
        $(e.currentTarget).find(".redPlus").addClass("redPlusActive");
      }
      $(e.currentTarget).nextAll(".channelFif").stop().slideToggle(500);

      $(e.currentTarget).nextAll(".BrandFifTie").css("display", "none");
    },
    showUpdata() {
      this.showDate = !this.showDate;
    },
    getList() {
      this.$addr
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getChannelByList")
        // .get("sellin/getChannelByList")
        .get("sellinAndsellout/getChannelByListSellInAndSellOut")
        .then((res) => {
          this.achVing = 0;
          this.achVing = parseFloat(sessionStorage.getItem("achVing"));

          res.data.data.forEach((item) => {
            // 宽度
            item.inWidth1 = this.getWidthPercent(
              item.SELLIN_TARGET_VALUE1_ACHEVE
            );

            item.inWidth2 = this.getWidthPercent(
              item.SELLIN_TARGET_VALUE2_ACHEVE
            );

            item.outWidth1 = this.getWidthPercent(
              item.SELLOUT_TARGET_VALUE1_ACHEVE
            );

            item.outWidth2 = this.getWidthPercent(
              item.SELLOUT_TARGET_VALUE2_ACHEVE
            );
            // 宽度

            // 背景颜色
            item.inClass1 = this.getDataClass(
              item.SELLIN_TARGET_VALUE1_ACHEVE,
              item.weekPattern,
              item.timeGone
            );

            item.inClass2 = this.getDataClass(
              item.SELLIN_TARGET_VALUE2_ACHEVE,
              item.weekPattern,
              item.timeGone
            );

            item.outClass1 = this.getDataClass(
              item.SELLOUT_TARGET_VALUE1_ACHEVE,
              item.weekPatternSellout,
              item.timeGoneSellout
            );

            item.outClass2 = this.getDataClass(
              item.SELLOUT_TARGET_VALUE2_ACHEVE,
              item.weekPatternSellout,
              item.timeGoneSellout
            );

            // 颜色
            item.inClass11 = this.getDataClassTitle(
              item.SELLIN_TARGET_VALUE1_ACHEVE,
              item.weekPattern,
              item.timeGone
            );

            item.outClass11 = this.getDataClassTitle(
              item.SELLOUT_TARGET_VALUE1_ACHEVE,
              item.weekPatternSellout,
              item.timeGoneSellout
            );

            // 颜色

            item.level1ByBrandList.forEach((item1) => {
              item1.inWidth1 = this.getWidthPercent(
                item1.SELLIN_TARGET_VALUE1_ACHEVE
              );

              item1.inWidth2 = this.getWidthPercent(
                item1.SELLIN_TARGET_VALUE2_ACHEVE
              );

              item1.outWidth1 = this.getWidthPercent(
                item1.SELLOUT_TARGET_VALUE1_ACHEVE
              );

              item1.outWidth2 = this.getWidthPercent(
                item1.SELLOUT_TARGET_VALUE2_ACHEVE
              );

              // 样式
              item1.inClass1 = this.getDataClass(
                item1.SELLIN_TARGET_VALUE1_ACHEVE,
                item1.weekPattern,
                item1.timeGone
              );

              item1.inClass2 = this.getDataClass(
                item1.SELLIN_TARGET_VALUE2_ACHEVE,
                item1.weekPattern,
                item1.timeGone
              );

              item1.outClass1 = this.getDataClass(
                item1.SELLOUT_TARGET_VALUE1_ACHEVE,
                item1.weekPatternSellout,
                item1.timeGoneSellout
              );

              item1.outClass2 = this.getDataClass(
                item1.SELLOUT_TARGET_VALUE2_ACHEVE,
                item1.weekPatternSellout,
                item1.timeGoneSellout
              );

              item1.inClass11 = this.getDataClassTitle(
                item1.SELLIN_TARGET_VALUE1_ACHEVE,
                item1.weekPattern,
                item1.timeGone
              );

              item1.outClass11 = this.getDataClassTitle(
                item1.SELLOUT_TARGET_VALUE1_ACHEVE,
                item1.weekPatternSellout,
                item1.timeGoneSellout
              );
            });

            item.levelList2.forEach((item1) => {
              item1.inWidth1 = this.getWidthPercent(
                item1.SELLIN_TARGET_VALUE1_ACHEVE
              );

              item1.inWidth2 = this.getWidthPercent(
                item1.SELLIN_TARGET_VALUE2_ACHEVE
              );

              item1.outWidth1 = this.getWidthPercent(
                item1.SELLOUT_TARGET_VALUE1_ACHEVE
              );

              item1.outWidth2 = this.getWidthPercent(
                item1.SELLOUT_TARGET_VALUE2_ACHEVE
              );

              // 样式
              item1.inClass1 = this.getDataClass(
                item1.SELLIN_TARGET_VALUE1_ACHEVE,
                item1.weekPattern,
                item1.timeGone
              );

              item1.inClass2 = this.getDataClass(
                item1.SELLIN_TARGET_VALUE2_ACHEVE,
                item1.weekPattern,
                item1.timeGone
              );

              item1.outClass1 = this.getDataClass(
                item1.SELLOUT_TARGET_VALUE1_ACHEVE,
                item1.weekPatternSellout,
                item1.timeGoneSellout
              );

              item1.outClass2 = this.getDataClass(
                item1.SELLOUT_TARGET_VALUE2_ACHEVE,
                item1.weekPatternSellout,
                item1.timeGoneSellout
              );

              item1.inClass11 = this.getDataClassTitle(
                item1.SELLIN_TARGET_VALUE1_ACHEVE,
                item1.weekPattern,
                item1.timeGone
              );

              item1.outClass11 = this.getDataClassTitle(
                item1.SELLOUT_TARGET_VALUE1_ACHEVE,
                item1.weekPatternSellout,
                item1.timeGoneSellout
              );

              item1.level2ByBrandList.forEach((item2) => {
                item2.inWidth1 = this.getWidthPercent(
                  item2.SELLIN_TARGET_VALUE1_ACHEVE
                );

                item2.inWidth2 = this.getWidthPercent(
                  item2.SELLIN_TARGET_VALUE2_ACHEVE
                );

                item2.outWidth1 = this.getWidthPercent(
                  item2.SELLOUT_TARGET_VALUE1_ACHEVE
                );

                item2.outWidth2 = this.getWidthPercent(
                  item2.SELLOUT_TARGET_VALUE2_ACHEVE
                );

                // 样式

                item2.inClass1 = this.getDataClass(
                  item2.SELLIN_TARGET_VALUE1_ACHEVE,
                  item2.weekPattern,
                  item2.timeGone
                );

                item2.inClass2 = this.getDataClass(
                  item2.SELLIN_TARGET_VALUE2_ACHEVE,
                  item2.weekPattern,
                  item2.timeGone
                );

                item2.outClass1 = this.getDataClass(
                  item2.SELLOUT_TARGET_VALUE1_ACHEVE,
                  item2.weekPatternSellout,
                  item2.timeGoneSellout
                );

                item2.outClass2 = this.getDataClass(
                  item2.SELLOUT_TARGET_VALUE2_ACHEVE,
                  item2.weekPatternSellout,
                  item2.timeGoneSellout
                );

                item2.inClass11 = this.getDataClassTitle(
                  item2.SELLIN_TARGET_VALUE1_ACHEVE,
                  item2.weekPattern,
                  item2.timeGone
                );

                item2.outClass11 = this.getDataClassTitle(
                  item2.SELLOUT_TARGET_VALUE1_ACHEVE,
                  item2.weekPatternSellout,
                  item2.timeGoneSellout
                );
              });

              item1.levelList3.forEach((item2) => {
                item2.inWidth1 = this.getWidthPercent(
                  item2.SELLIN_TARGET_VALUE1_ACHEVE
                );

                item2.inWidth2 = this.getWidthPercent(
                  item2.SELLIN_TARGET_VALUE2_ACHEVE
                );

                item2.outWidth1 = this.getWidthPercent(
                  item2.SELLOUT_TARGET_VALUE1_ACHEVE
                );

                item2.outWidth2 = this.getWidthPercent(
                  item2.SELLOUT_TARGET_VALUE2_ACHEVE
                );

                // 样式

                item2.inClass1 = this.getDataClass(
                  item2.SELLIN_TARGET_VALUE1_ACHEVE,
                  item2.weekPattern,
                  item2.timeGone
                );

                item2.inClass2 = this.getDataClass(
                  item2.SELLIN_TARGET_VALUE2_ACHEVE,
                  item2.weekPattern,
                  item2.timeGone
                );

                item2.outClass1 = this.getDataClass(
                  item2.SELLOUT_TARGET_VALUE1_ACHEVE,
                  item2.weekPatternSellout,
                  item2.timeGoneSellout
                );

                item2.outClass2 = this.getDataClass(
                  item2.SELLOUT_TARGET_VALUE2_ACHEVE,
                  item1.weekPatternSellout,
                  item1.timeGoneSellout
                );

                item2.inClass11 = this.getDataClassTitle(
                  item2.SELLIN_TARGET_VALUE1_ACHEVE,
                  item2.weekPattern,
                  item2.timeGone
                );

                item2.outClass11 = this.getDataClassTitle(
                  item2.SELLOUT_TARGET_VALUE1_ACHEVE,
                  item2.weekPatternSellout,
                  item2.timeGoneSellout
                );

                item2.level3ByBrandList.forEach((item3) => {
                  item3.inWidth1 = this.getWidthPercent(
                    item3.SELLIN_TARGET_VALUE1_ACHEVE
                  );

                  item3.inWidth2 = this.getWidthPercent(
                    item3.SELLIN_TARGET_VALUE2_ACHEVE
                  );

                  item3.outWidth1 = this.getWidthPercent(
                    item3.SELLOUT_TARGET_VALUE1_ACHEVE
                  );

                  item3.outWidth2 = this.getWidthPercent(
                    item3.SELLOUT_TARGET_VALUE2_ACHEVE
                  );

                  // 样式

                  item3.inClass1 = this.getDataClass(
                    item3.SELLIN_TARGET_VALUE1_ACHEVE,
                    item3.weekPattern,
                    item3.timeGone
                  );

                  item3.inClass2 = this.getDataClass(
                    item3.SELLIN_TARGET_VALUE2_ACHEVE,
                    item3.weekPattern,
                    item3.timeGone
                  );

                  item3.outClass1 = this.getDataClass(
                    item3.SELLOUT_TARGET_VALUE1_ACHEVE,
                    item3.weekPatternSellout,
                    item3.timeGoneSellout
                  );

                  item3.outClass2 = this.getDataClass(
                    item3.SELLOUT_TARGET_VALUE2_ACHEVE,
                    item3.weekPatternSellout,
                    item3.timeGoneSellout
                  );

                  item3.inClass11 = this.getDataClassTitle(
                    item3.SELLIN_TARGET_VALUE1_ACHEVE,
                    item3.weekPattern,
                    item3.timeGone
                  );

                  item3.outClass11 = this.getDataClassTitle(
                    item3.SELLOUT_TARGET_VALUE1_ACHEVE,
                    item3.weekPatternSellout,
                    item3.timeGoneSellout
                  );
                });

                item2.levelList4.forEach((item3) => {
                  item3.inWidth1 = this.getWidthPercent(
                    item3.SELLIN_TARGET_VALUE1_ACHEVE
                  );

                  item3.inWidth2 = this.getWidthPercent(
                    item3.SELLIN_TARGET_VALUE2_ACHEVE
                  );

                  item3.outWidth1 = this.getWidthPercent(
                    item3.SELLOUT_TARGET_VALUE1_ACHEVE
                  );

                  item3.outWidth2 = this.getWidthPercent(
                    item3.SELLOUT_TARGET_VALUE2_ACHEVE
                  );

                  // 样式

                  item3.inClass1 = this.getDataClass(
                    item3.SELLIN_TARGET_VALUE1_ACHEVE,
                    item3.weekPattern,
                    item3.timeGone
                  );

                  item3.inClass2 = this.getDataClass(
                    item3.SELLIN_TARGET_VALUE2_ACHEVE,
                    item3.weekPattern,
                    item3.timeGone
                  );

                  item3.outClass1 = this.getDataClass(
                    item3.SELLOUT_TARGET_VALUE1_ACHEVE,
                    item3.weekPatternSellout,
                    item3.timeGoneSellout
                  );

                  item3.outClass2 = this.getDataClass(
                    item3.SELLOUT_TARGET_VALUE2_ACHEVE,
                    item3.weekPatternSellout,
                    item3.timeGoneSellout
                  );

                  item3.inClass11 = this.getDataClassTitle(
                    item3.SELLIN_TARGET_VALUE1_ACHEVE,
                    item3.weekPattern,
                    item3.timeGone
                  );

                  item3.outClass11 = this.getDataClassTitle(
                    item3.SELLOUT_TARGET_VALUE1_ACHEVE,
                    item3.weekPatternSellout,
                    item3.timeGoneSellout
                  );

                  item3.level4ByBrandList.forEach((item4) => {
                    item4.inWidth1 = this.getWidthPercent(
                      item4.SELLIN_TARGET_VALUE1_ACHEVE
                    );

                    item4.inWidth2 = this.getWidthPercent(
                      item4.SELLIN_TARGET_VALUE2_ACHEVE
                    );

                    item4.outWidth1 = this.getWidthPercent(
                      item4.SELLOUT_TARGET_VALUE1_ACHEVE
                    );

                    item4.outWidth2 = this.getWidthPercent(
                      item4.SELLOUT_TARGET_VALUE2_ACHEVE
                    );

                    // 样式

                    item4.inClass1 = this.getDataClass(
                      item4.SELLIN_TARGET_VALUE1_ACHEVE,
                      item4.weekPattern,
                      item4.timeGone
                    );

                    item4.inClass2 = this.getDataClass(
                      item4.SELLIN_TARGET_VALUE2_ACHEVE,
                      item4.weekPattern,
                      item4.timeGone
                    );

                    item4.outClass1 = this.getDataClass(
                      item4.SELLOUT_TARGET_VALUE1_ACHEVE,
                      item4.weekPatternSellout,
                      item4.timeGoneSellout
                    );

                    item4.outClass2 = this.getDataClass(
                      item4.SELLOUT_TARGET_VALUE2_ACHEVE,
                      item4.weekPatternSellout,
                      item4.timeGoneSellout
                    );

                    item4.inClass11 = this.getDataClassTitle(
                      item4.SELLIN_TARGET_VALUE1_ACHEVE,
                      item4.weekPattern,
                      item4.timeGone
                    );

                    item4.outClass11 = this.getDataClassTitle(
                      item4.SELLOUT_TARGET_VALUE1_ACHEVE,
                      item4.weekPatternSellout,
                      item4.timeGoneSellout
                    );
                  });
                  //增加第五层级
                  item3.levelList5.forEach((item4) => {
                    item4.inWidth1 = this.getWidthPercent(
                      item4.SELLIN_TARGET_VALUE1_ACHEVE
                  );

                  item4.inWidth2 = this.getWidthPercent(
                    item4.SELLIN_TARGET_VALUE2_ACHEVE
                  );

                  item4.outWidth1 = this.getWidthPercent(
                    item4.SELLOUT_TARGET_VALUE1_ACHEVE
                  );

                  item4.outWidth2 = this.getWidthPercent(
                    item4.SELLOUT_TARGET_VALUE2_ACHEVE
                  );

                  // 样式

                  item4.inClass1 = this.getDataClass(
                    item4.SELLIN_TARGET_VALUE1_ACHEVE,
                    item4.weekPattern,
                    item4.timeGone
                  );

                  item4.inClass2 = this.getDataClass(
                    item4.SELLIN_TARGET_VALUE2_ACHEVE,
                    item4.weekPattern,
                    item4.timeGone
                  );

                  item4.outClass1 = this.getDataClass(
                    item4.SELLOUT_TARGET_VALUE1_ACHEVE,
                    item4.weekPatternSellout,
                    item4.timeGoneSellout
                  );

                  item4.outClass2 = this.getDataClass(
                    item4.SELLOUT_TARGET_VALUE2_ACHEVE,
                    item4.weekPatternSellout,
                    item4.timeGoneSellout
                  );

                  item4.inClass11 = this.getDataClassTitle(
                    item4.SELLIN_TARGET_VALUE1_ACHEVE,
                    item4.weekPattern,
                    item4.timeGone
                  );

                  item4.outClass11 = this.getDataClassTitle(
                    item4.SELLOUT_TARGET_VALUE1_ACHEVE,
                    item4.weekPatternSellout,
                    item4.timeGoneSellout
                  );

                  item3.level5ByBrandList.forEach((item5) => {
                    item5.inWidth1 = this.getWidthPercent(
                      item5.SELLIN_TARGET_VALUE1_ACHEVE
                    );

                    item5.inWidth2 = this.getWidthPercent(
                      item5.SELLIN_TARGET_VALUE2_ACHEVE
                    );

                    item5.outWidth1 = this.getWidthPercent(
                      item5.SELLOUT_TARGET_VALUE1_ACHEVE
                    );

                    item5.outWidth2 = this.getWidthPercent(
                      item5.SELLOUT_TARGET_VALUE2_ACHEVE
                    );

                    // 样式

                    item5.inClass1 = this.getDataClass(
                      item5.SELLIN_TARGET_VALUE1_ACHEVE,
                      item5.weekPattern,
                      item5.timeGone
                    );

                    item5.inClass2 = this.getDataClass(
                      item5.SELLIN_TARGET_VALUE2_ACHEVE,
                      item5.weekPattern,
                      item5.timeGone
                    );

                    item5.outClass1 = this.getDataClass(
                      item5.SELLOUT_TARGET_VALUE1_ACHEVE,
                      item5.weekPatternSellout,
                      item5.timeGoneSellout
                    );

                    item5.outClass2 = this.getDataClass(
                      item5.SELLOUT_TARGET_VALUE2_ACHEVE,
                      item5.weekPatternSellout,
                      item5.timeGoneSellout
                    );

                    item5.inClass11 = this.getDataClassTitle(
                      item5.SELLIN_TARGET_VALUE1_ACHEVE,
                      item5.weekPattern,
                      item5.timeGone
                    );

                    item5.outClass11 = this.getDataClassTitle(
                      item5.SELLOUT_TARGET_VALUE1_ACHEVE,
                      item5.weekPatternSellout,
                      item5.timeGoneSellout
                    );
                  });
                });
                });
              });
            });
          });

          this.tableList = res.data.data;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getType() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        // .get("sellin/getTargetType")
        .get("sellinAndsellout/getTargetTypeSellinAndSellout")
        .then((res) => {
          if (res.data.error == 0) {
            let resultData = res.data.data[0];
            this.type1 = resultData.SELLOUT_TARGETTYPE1;
            this.type2 = resultData.SELLOUT_TARGETTYPE2;

            this.type3 = resultData.SELLOUT_TARGETTYPE_BTG1;
            this.type4 = resultData.SELLOUT_TARGETTYPE_BTG2;
          }
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },

    getTypeData() {
      this.$addr
        .get("sellinAndsellout/getSumDataSellinAndSellout")
        .then((res) => {
          if (res.data.error == 0) {
            this.typeValue = res.data.data[0];

            if (this.typeValue.weekPattern) {
              // Weekly Pattern
              this.weekPatternFlag = true;
              this.type5 = "pattern";
            } else {
              // Time Gone
              this.weekPatternFlag = false;
              this.type5 = "Time Gone";
            }
          }
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },

    changeImg(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red redActive") {
        $(e.currentTarget).find(".red").removeClass("redActive");
      }
      if (
        $(e.currentTarget).find(".redPlus").attr("class") ==
        "redPlus redPlusActiveImg"
      ) {
        $(e.currentTarget).find(".redPlus").removeClass("redPlusActiveImg");
      } else {
        $(e.currentTarget).find(".redPlus").addClass("redPlusActiveImg");
      }
      $(e.currentTarget).nextAll(".ChannelList1").stop().slideToggle(500);
      $(e.currentTarget).nextAll(".BrandOneTie").css("display", "none");
    },
  },
  created() {
    this.getList();
    this.getType();

    this.getTypeData();
  },
  components: {
    Mymap,
  },
};
</script>
<style scoped>
.clickInfo {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
}

.proBoxsLeft {
  display: flex;
  justify-content: left;
  align-items: center;
  /* margin-top: 10px; */
}

.proBoxsRight {
  display: flex;
  justify-content: right;
  align-items: center;
  margin-right: 8px;
  /* margin-top: 10px; */
}
.clickInfo p {
  color: #424242;
  letter-spacing: 0;
  text-align: center;
  font-family: "微软雅黑" !important;
  font-size: 10px;
}
.showDate {
  padding: 20px;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #191919;
  border: 1px solid black;
  z-index: 999999999999999;
  position: absolute;
  top: 30px;
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 20px;
  width: 90%;
}

ul li {
  margin-bottom: 2px;
  font-size: 10px;
  color: #191919;
  width: 100%;
  height: 20px;
  /* 强制不换行 */
  text-overflow: ellipsis;
  border-bottom: 1px solid rgba(157, 157, 157, 0.4);
  line-height: 20px;
}
.SelTop {
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.SelTop .sel_right {
  position: relative;
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
  width: 450px;
  height: 21px;
  background: rgba(152, 152, 152, 0.5);
  box-shadow: inset 0 0 5px 0 #9e9e9e;
  border-radius: 42.5px;
  margin-left: 10px;
  margin-bottom: 10px;
}

.SelTop .sel_right p {
  float: left;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  line-height: 21px;
  color: #f9f9f9;
  padding-left: 13px;
}

.progressBox {
  width: 86%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px -1px rgba(90, 66, 37, 0.5);
  padding: 5px 6px;
  box-sizing: border-box;
  /* padding: 5px 8px; */
}

.SelTop .sel_right b {
  float: right;
  margin-right: 5px;
  margin-top: 5px;
  text-align: center;
  line-height: 12px;
  font-size: 10px;
  background: #f9f9f9;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.red {
  font-size: 16px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 100%;
  transform: scaleX(-1);
  box-shadow: 0 0 5px -1px rgba(90, 66, 37, 0.5);
  border-radius: 10px 0px 0px 10px;
}
.redActive {
  display: flex;
  align-items: center;
  padding: 0 10px;
  transform: scaleX(-1);
  box-shadow: inset 0 0 5px 0 rgba(59, 59, 59, 0.5);
  border-radius: 10px 0px 0px 10px;
}
.red img {
  width: 17px;
  height: 17px;
}
.redPlus {
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 6px;
}
.redPlus img {
  width: 24px;
  height: 24px;
}
.redPlusActive > img {
  transform: rotate(90deg);
}
.redPlusActiveImg > img {
  transform: rotate(-90deg);
}
.LittleBut {
  height: 20px;
  width: 20px;
  text-align: center;
  background: rgba(158, 131, 108, 0.3);
  border-radius: 50%;
  line-height: 20px;
}
.notice {
  background: #c7544d !important;
}

.title {
  font-weight: 700;
  margin: 10px 0px 8px 0px;
  display: flex;
  justify-content: left;
}

.noticeCol {
  background: #f9c6bd !important;
}
.noticeFormat {
  color: #c7544d !important;
}
.helthyFormat {
  color: #84a05f !important;
}

.pinFormat {
  color: #e9c978 !important;
}
.pinCol {
  background: #f3d480 !important;
}
.helthyCol {
  background: #d4e1b4 !important;
}
.helthy {
  background: #84a05f !important;
}
.pin {
  background: #f3d480 !important;
}
.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list b {
  text-align: right;
  min-width: 50px;
  font-family: "微软雅黑" !important;
  height: 37px;
  line-height: 37px;
  font-size: 15px;
  color: #3a3a3b;
}
.list span {
  text-align: left;
  font-family: "微软雅黑" !important;
  height: 37px;
  min-width: 50px;
  line-height: 37px;
  font-size: 15px;
  color: #3a3a3b;
}
.tableLeft {
  /* padding: 12px 5px 13px 22px; */
  /* padding: 10px 5px; */
  display: flex;
  justify-content: left;
  align-items: center;
  flex-direction: column;
  /* min-height: 45px; */
}
.tableLeft .tableTop {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tableLeft .tableTop span {
  font-family: "微软雅黑" !important;
  font-size: 12px;
  color: #3a3a3b;
  white-space: nowrap;
}

.tableLeft .tabMid {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.tableLeft .tabMid b {
  /* margin-top: 4px; */
  min-width: 100%;
  text-align: left;
  font-family: "微软雅黑" !important;
  font-size: 16px;
}

.tableRight .tabMid b {
  margin-top: 4px;
  min-width: 100%;
  text-align: left;
  font-family: "微软雅黑" !important;
  font-size: 16px;
}

.TwoTie .progress {
  width: 95.2%;
}
.TwoTie .tableLeft .tableTop span {
  overflow: hidden;
  white-space: nowrap;
}
.progress {
  /* margin-top: 6px;
  margin-bottom: 6px; */
  /* margin: 6px 0px; */
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.textTitle {
  font-size: 8px;
  white-space: nowrap;
  text-align: left;
  margin: 4px 0;
}
.progress span {
  width: 100%;
  display: block;
  background: #dddde9;
  border-radius: 5px;
  height: 12px;
}

.progress label {
  font-size: 6px;
  white-space: nowrap;
  margin: 2px;
}

.progress span p {
  display: block;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #f6f6ff;
  line-height: 14px;
  border-radius: 5px;
  text-align: right;
  /* padding-right: 6px; */
}
.vsProgress span {
  width: 100%;
  display: block;
  background: #dddde9;
  border-radius: 5px;
  height: 14px;
  line-height: 20px;
  box-sizing: border-box;

  margin-top: 3px;
}
.vsProgress span p {
  display: block;
  width: 50%;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #4f4779;
  line-height: 14px;
  border-radius: 5px;
  text-align: right;
  padding-right: 6px;
}
.tableLeft span {
  font-family: "微软雅黑" !important;
  font-size: 12px;
  font-weight: 600;
  color: #4f4779;
}
.tableLeft b {
  font-family: "微软雅黑" !important;
  font-size: 15px;
  color: #84a05f;
}
.tableRight {
  padding: auto 4px;
  /* margin-top: 12px; */
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.tableLeft .leftFlex {
  padding-left: 8px;
  position: relative;
  margin-bottom: 1px;
  width: 100%;
  display: flex;
  justify-content: left;
  line-height: 20px;
}

.tableCenter {
  /* padding: 4px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tableCenter .centerFlex {
  position: relative;
  margin-bottom: 1px;
  width: 100%;
  display: flex;
  color: #3a3a3b;
  justify-content: center;
  line-height: 20px;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
}

.tableRight .rightFlex {
  padding-right: 8px;
  position: relative;
  margin-bottom: 1px;
  width: 100%;
  line-height: 20px;
  display: flex;
  justify-content: right;
}
.tableRight .rightFlex span {
  /* min-width: 60px; */
  font-family: "微软雅黑" !important;
  font-size: 12px;
  font-weight: 600;
  color: #4f4779;
  text-align: right;
  display: flex;
  justify-content: end;
}
.tableRight .rightFlex b {
  text-align: right;
  min-width: 50px;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #332a66;
}
.tableRight .rightFlex i {
  font-style: normal;
  text-align: left;
  min-width: 60px;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #3a3a3b;
}
.tableRight .rightFlex img {
  position: absolute;
  width: 12px;
  height: 12px;
  left: 8px;
  top: -3px;
}
.box {
  margin: 1.5px auto 0;
  padding: 0 7px;
  position: relative;
}
.OneTie {
  position: relative;

  margin-left: 5px;
  width: 97%;
  /* height: 144px; */
  height: 100px;
  background: #ffffff;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  /* line-height: 20px; */
  /* text-align: right;
  text-align: center; */

  font-family: "微软雅黑" !important;

  font-size: 12px;
  color: #000000;
  margin-bottom: 10px;
  z-index: 999;
}
.OneTieactive {
  width: 104%;
  margin-left: -9px;
  background: #B1E0DA;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  font-size: 12px;
}
.TwoTieactive {
  background: #D3ECE685;
}
.TwoTieAct {
  background: #EEF9F382;
  margin-bottom: 8px;
  width: 96%;
  border-radius: 10px;
  margin-left: 7px;
}
.ly {
  margin-left: 10px;
  display: inline-block;
  width: 40px;
  height: 12px;
  line-height: 12px;
  text-align: center !important;
  border-radius: 6px;
  background: #d4e1b4;
}
.TwoTie {
  text-align: center;
  border-radius: 10px;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #191919;

  height: 100px;
  /* line-height: 20px; */
  z-index: 999;
  box-shadow: 0 5px 20px -10px #704f4f;
}

.middleContentCenter {
  margin-top: -5px;
}

.BrandThrTie,
.BrandForTie,
.BrandFifTie {
  border-bottom: 2px solid rgba(157, 157, 157, 0.4);
  text-align: center;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #191919;
  /* height: 144px; */

  height: 100px;
  /* line-height: 20px; */
  z-index: 999;
}

.channelThr {
  /* height: 130px; */
}
</style>


// WEBPACK FOOTER //
// src/components/ButSecoend/Summary/SumTable.vue